// import React, { Fragment, useState, useEffect } from 'react';
// import { useParams, useHistory } from 'react-router-dom';
// import { fetchData, updateData, postData } from '../../../apiService';
// import { faL } from '@fortawesome/free-solid-svg-icons';
// import TableContainer from '@mui/material/TableContainer';
// import Paper from '@mui/material/Paper';
// import IconButton from '@mui/material/IconButton';
// import DeleteIcon from '@mui/icons-material/Delete';
// import EditIcon from '@mui/icons-material/Edit';
// import { useAuth } from '../../../AuthContext';
// import { tokenIsExpired } from '../../../authUtils';
// import Button from '@mui/material/Button';
// import { Link } from 'react-router-dom';
// import Select from 'react-select';
// import CircularProgress from '@mui/material/CircularProgress';
// import BillPrint from '../salereturn/Bill';
// import ReactDOM from 'react-dom';
// import AddIcon from '@mui/icons-material/Add';
// import DoneIcon from '@mui/icons-material/Done';
// import CloseIcon from '@mui/icons-material/Close';
// import CopyrightIcon from '@mui/icons-material/Copyright';
// import AsyncSelect from 'react-select/async';
// import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
// import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
// import DoneAllIcon from '@mui/icons-material/DoneAll';

// const SaleReturnEdit = () => {
//     const { id } = useParams(); // Use useParams to get the id from the URL
//     const history = useHistory();
//     const [successMessage, setSuccessMessage] = useState("");
//     const [errorMessage, setErrorMessage] = useState("");
//     const [errorMessageModel, setErrorMessageModel] = useState('');
//     const [isLoading, setIsLoading] = useState(false);
//     const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate, roleName } = useAuth();

//     const [selectedSalesMan, setSelectedSalesMan] = useState("");
//     const [dropdownSalesManOptions, setDropdownSalesManOptions] = useState([]);

//     const [selectedCardType, setSelectedCardType] = useState("");
//     const [dropdownCardTypeOptions, setDropdownCardTypeOptions] = useState([]);

//     const [showCardFields, setShowCardFields] = useState(false);
//     const [showupiFields, setShowupiFields] = useState(false);

//     useEffect(() => {
//         if (isAuthenticated && tokenIsExpired(token)) {
//             logout();
//             return;
//         }
//     }, [isAuthenticated, companyId, branchId, token, logout]);

//     useEffect(() => {
//         fetchDropdownSalesManOptions();
//         fetchDropdownCardTypeOptions();
//     }, []);

//     const fetchOptions = async (inputValue) => {
//         if (inputValue.length <= 4) {
//             return [];
//         }

//         const response = await fetchData('PurchaseApi', `/Item/${companyId}/${branchId}/${inputValue}`, token);
//         if (response.responseCode === '1111') {
//             const data = await response.response_data;
//             return data.map(item => ({
//                 value: item.Id,
//                 label: item.Code + '-' + item.Name,
//             }));
//         }
//     };

//     const fetchDropdownSalesManOptions = () => {
//         fetchData('SaleReturnApi', `/SalesMan/${companyId}/${branchId}`, token)
//             .then((response) => response.response_data)
//             .then((data) => {
//                 setDropdownSalesManOptions(data);
//             })
//             .catch((error) => {
//                 console.error('Error fetching Sales Man dropdown options:', error);
//             });
//     };

//     const fetchDropdownCardTypeOptions = () => {
//         fetchData('SaleReturnApi', `/CardType/${companyId}/${branchId}`, token)
//             .then((response) => response.response_data)
//             .then((data) => {
//                 setDropdownCardTypeOptions(data);
//             })
//             .catch((error) => {
//                 console.error('Error fetching Card Type dropdown options:', error);
//             });
//     };

//     const hasCreateTransactionPermission = permissions.includes('Create Transaction');
//     const hasEditTransactionPermission = permissions.includes('Edit Transaction');
//     const hasDeleteTransactionPermission = permissions.includes('Delete Transaction');

//     const [formData, setFormData] = useState([]);
//     const [invoicedeatils, setInvoicedeatils] = useState([]);

//     useEffect(() => {
//         fetchData('SaleReturnApi', `/${id}`, token)
//             .then((response) => {
//                 if (response.responseCode === '1111') {
//                     setFormData(response.response_data.Sale);
//                     setInvoicedeatils(response.response_data.SaleDetails);
//                     setFormData(prevData => ({
//                         ...prevData,
//                         UpdatedBy: userId,
//                     }));

//                     setSelectedSalesMan(response.response_data.Sale.SalesManId);
//                     setSelectedCardType(response.response_data.Sale.CardType);
//                 }
//             })
//             .catch((error) => {
//                 console.error('Error fetching Sale Details:', error);
//             });
//     }, [id]);

//     const handleChange = (event) => {
//         const { name, value, type, checked } = event.target;

//         if (name === 'GVAmount') {
//             const gvamt = parseFloat(value) || 0;
//             setFormData((prevData) => ({
//                 ...prevData,
//                 GVAmount: gvamt.toFixed(2),
//                 ModifiedBy: userId,
//             }));

//             const AdditionalDisc = parseFloat(formData.AdditionalDiscountPercentage) || 0;

//             const updatedItemData = invoicedeatils.map((item) => {

//                 let rate = parseFloat(item.Rate) || 0;
//                 let gstrate = parseFloat(item.GSTRate) || 0;
//                 let discountPercentage = parseFloat(item.DiscountPercentage) || 0;
//                 let quantity = parseFloat(item.Quantity) || 0;
//                 let amount = (quantity * rate).toFixed(2);
//                 let discamt = ((rate * discountPercentage) / 100).toFixed(2)
//                 let Addidiscamt = ((rate * AdditionalDisc) / 100).toFixed(2)
//                 let totdiscount = parseFloat(discamt) + parseFloat(Addidiscamt);
//                 let grate = (rate - totdiscount).toFixed(2);
//                 let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
//                 const taxableamount = (quantity * salerate).toFixed(2);
//                 const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

//                 let cgst = 0;
//                 let sgst = 0;
//                 let igst = 0;

//                 if (!formData.GSTNumber) {
//                     cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
//                     sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
//                 } else {
//                     const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

//                     if (gstNumberPrefix !== branchstate) {
//                         igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
//                     } else {
//                         cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
//                         sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
//                     }
//                 }

//                 const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

//                 return {
//                     ...item,
//                     Amount: amount,
//                     DiscountAmount: parseFloat(discamt * quantity).toFixed(2),
//                     AdditionalDiscountAmount: parseFloat(Addidiscamt * quantity).toFixed(2),
//                     AdditionalDiscountPercentage: parseFloat(AdditionalDisc).toFixed(2),
//                     TaxableAmount: parseFloat(taxableamount).toFixed(2),
//                     CGSTAmount: parseFloat(cgst).toFixed(2),
//                     SGSTAmount: parseFloat(sgst).toFixed(2),
//                     IGSTAmount: parseFloat(igst).toFixed(2),
//                     TotalAmount: parseFloat(totalAmount).toFixed(2),
//                 };
//             });

//             setInvoicedeatils(updatedItemData);

//             const Quantity = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
//             const Amount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
//             const DiscountAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
//             const TaxableAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
//             const CGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
//             const SGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
//             const IGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
//             const TotalAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);

//             const CardAmount = parseFloat(formData.CardAmount) || 0;
//             const UPIAmount = parseFloat(formData.UPIAmount) || 0;
//             totalCalculation(Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvamt, CardAmount, UPIAmount);
//         }
//         else if (name === 'GSTNumber') {
//             const gstno = value;
//             setFormData((prevData) => ({
//                 ...prevData,
//                 GSTNumber: gstno,
//                 ModifiedBy: userId,
//             }));

//             const AdditionalDisc = parseFloat(formData.AdditionalDiscountPercentage) || 0;

//             const updatedItemData = invoicedeatils.map((item) => {

//                 let rate = parseFloat(item.Rate) || 0;
//                 let gstrate = parseFloat(item.GSTRate) || 0;
//                 let discountPercentage = parseFloat(item.DiscountPercentage) || 0;
//                 let quantity = parseFloat(item.Quantity) || 0;
//                 let amount = (quantity * rate).toFixed(2);
//                 let discamt = ((rate * discountPercentage) / 100).toFixed(2)
//                 let Addidiscamt = ((rate * AdditionalDisc) / 100).toFixed(2)
//                 let totdiscount = parseFloat(discamt) + parseFloat(Addidiscamt);
//                 let grate = (rate - totdiscount).toFixed(2);
//                 let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
//                 const taxableamount = (quantity * salerate).toFixed(2);
//                 const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

//                 let cgst = 0;
//                 let sgst = 0;
//                 let igst = 0;

//                 if (!gstno) {
//                     cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
//                     sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
//                 } else {
//                     const gstNumberPrefix = gstno.toString().substring(0, 2);

//                     if (gstNumberPrefix !== branchstate) {
//                         igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
//                     } else {
//                         cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
//                         sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
//                     }
//                 }

//                 const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

//                 return {
//                     ...item,
//                     Amount: amount,
//                     AdditionalDiscountAmount: parseFloat(Addidiscamt * quantity).toFixed(2),
//                     AdditionalDiscountPercentage: parseFloat(AdditionalDisc).toFixed(2),
//                     DiscountAmount: parseFloat(discamt * quantity).toFixed(2),
//                     TaxableAmount: parseFloat(taxableamount).toFixed(2),
//                     CGSTAmount: parseFloat(cgst).toFixed(2),
//                     SGSTAmount: parseFloat(sgst).toFixed(2),
//                     IGSTAmount: parseFloat(igst).toFixed(2),
//                     TotalAmount: parseFloat(totalAmount).toFixed(2),
//                 };
//             });

//             setInvoicedeatils(updatedItemData);

//             const Quantity = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
//             const Amount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
//             const DiscountAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
//             const TaxableAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
//             const CGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
//             const SGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
//             const IGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
//             const TotalAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);
//             const gvAmount = parseFloat(formData.GVAmount) || 0;
//             const CardAmount = parseFloat(formData.CardAmount) || 0;
//             const UPIAmount = parseFloat(formData.UPIAmount) || 0;
//             totalCalculation(Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvAmount, CardAmount, UPIAmount);

//         }
//         else if (name === 'CardAmount') {

//             const cardAmount = parseFloat(value) || 0;
//             setFormData((prevData) => ({
//                 ...prevData,
//                 CardAmount: cardAmount.toFixed(2),
//                 ModifiedBy: userId,
//             }));
//             const AdditionalDisc = parseFloat(formData.AdditionalDiscountPercentage) || 0;
//             const updatedItemData = invoicedeatils.map((item) => {

//                 let rate = parseFloat(item.Rate) || 0;
//                 let gstrate = parseFloat(item.GSTRate) || 0;
//                 let discountPercentage = parseFloat(item.DiscountPercentage) || 0;
//                 let quantity = parseFloat(item.Quantity) || 0;
//                 let amount = (quantity * rate).toFixed(2);
//                 let discamt = ((rate * discountPercentage) / 100).toFixed(2)
//                 let Addidiscamt = ((rate * AdditionalDisc) / 100).toFixed(2)
//                 let totdiscount = parseFloat(discamt) + parseFloat(Addidiscamt);
//                 let grate = (rate - totdiscount).toFixed(2);
//                 let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
//                 const taxableamount = (quantity * salerate).toFixed(2);
//                 const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

//                 let cgst = 0;
//                 let sgst = 0;
//                 let igst = 0;

//                 if (!formData.GSTNumber) {
//                     cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
//                     sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
//                 } else {
//                     const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

//                     if (gstNumberPrefix !== branchstate) {
//                         igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
//                     } else {
//                         cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
//                         sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
//                     }
//                 }

//                 const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

//                 return {
//                     ...item,
//                     Amount: amount,
//                     AdditionalDiscountAmount: parseFloat(Addidiscamt * quantity).toFixed(2),
//                     AdditionalDiscountPercentage: parseFloat(AdditionalDisc).toFixed(2),
//                     DiscountAmount: parseFloat(discamt * quantity).toFixed(2),
//                     TaxableAmount: parseFloat(taxableamount).toFixed(2),
//                     CGSTAmount: parseFloat(cgst).toFixed(2),
//                     SGSTAmount: parseFloat(sgst).toFixed(2),
//                     IGSTAmount: parseFloat(igst).toFixed(2),
//                     TotalAmount: parseFloat(totalAmount).toFixed(2),
//                 };
//             });

//             setInvoicedeatils(updatedItemData);

//             const Quantity = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
//             const Amount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
//             const DiscountAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
//             const TaxableAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
//             const CGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
//             const SGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
//             const IGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
//             const TotalAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);
//             const gvAmount = parseFloat(formData.GVAmount) || 0;
//             const UPIAmount = parseFloat(formData.UPIAmount) || 0;
//             totalCalculation(Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvAmount, cardAmount, UPIAmount);

//         }
//         else if (name === 'AdditionalDiscountPercentage') {

//             const AdditionalDiscountPercentage = parseFloat(value) || 0;
//             setFormData((prevData) => ({
//                 ...prevData,
//                 AdditionalDiscountPercentage: AdditionalDiscountPercentage.toFixed(2),
//                 ModifiedBy: userId,
//             }));
//             const AdditionalDisc = parseFloat(AdditionalDiscountPercentage) || 0;
//             const updatedItemData = invoicedeatils.map((item) => {

//                 let rate = parseFloat(item.Rate) || 0;
//                 let gstrate = parseFloat(item.GSTRate) || 0;
//                 let discountPercentage = parseFloat(item.DiscountPercentage) || 0;
//                 let quantity = parseFloat(item.Quantity) || 0;
//                 let amount = (quantity * rate).toFixed(2);
//                 let discamt = ((rate * discountPercentage) / 100).toFixed(2)
//                 let Addidiscamt = ((rate * AdditionalDisc) / 100).toFixed(2)
//                 let totdiscount = parseFloat(discamt) + parseFloat(Addidiscamt);
//                 let grate = (rate - totdiscount).toFixed(2);
//                 let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
//                 const taxableamount = (quantity * salerate).toFixed(2);
//                 const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

//                 let cgst = 0;
//                 let sgst = 0;
//                 let igst = 0;

//                 if (!formData.GSTNumber) {
//                     cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
//                     sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
//                 } else {
//                     const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

//                     if (gstNumberPrefix !== branchstate) {
//                         igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
//                     } else {
//                         cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
//                         sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
//                     }
//                 }

//                 const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

//                 return {
//                     ...item,
//                     Amount: amount,
//                     AdditionalDiscountAmount: parseFloat(Addidiscamt * quantity).toFixed(2),
//                     AdditionalDiscountPercentage: parseFloat(AdditionalDisc).toFixed(2),
//                     DiscountAmount: parseFloat(discamt * quantity).toFixed(2),
//                     TaxableAmount: parseFloat(taxableamount).toFixed(2),
//                     CGSTAmount: parseFloat(cgst).toFixed(2),
//                     SGSTAmount: parseFloat(sgst).toFixed(2),
//                     IGSTAmount: parseFloat(igst).toFixed(2),
//                     TotalAmount: parseFloat(totalAmount).toFixed(2),
//                 };
//             });

//             setInvoicedeatils(updatedItemData);

//             const Quantity = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
//             const Amount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
//             const DiscountAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
//             const TaxableAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
//             const CGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
//             const SGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
//             const IGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
//             const TotalAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);
//             const gvAmount = parseFloat(formData.GVAmount) || 0;
//             const CardAmount = parseFloat(formData.CardAmount) || 0;
//             const UPIAmount = parseFloat(formData.UPIAmount) || 0;
//             totalCalculation(Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvAmount, CardAmount, UPIAmount);

//         }
//         else if (name === 'UPIAmount') {

//             const upiAmount = parseFloat(value) || 0;
//             setFormData((prevData) => ({
//                 ...prevData,
//                 UPIAmount: upiAmount.toFixed(2),
//                 ModifiedBy: userId,
//             }));
//             const AdditionalDisc = parseFloat(formData.AdditionalDiscountPercentage) || 0;
//             const updatedItemData = invoicedeatils.map((item) => {

//                 let rate = parseFloat(item.Rate) || 0;
//                 let gstrate = parseFloat(item.GSTRate) || 0;
//                 let discountPercentage = parseFloat(item.DiscountPercentage) || 0;
//                 let quantity = parseFloat(item.Quantity) || 0;
//                 let amount = (quantity * rate).toFixed(2);
//                 let discamt = ((rate * discountPercentage) / 100).toFixed(2)
//                 let Addidiscamt = ((rate * AdditionalDisc) / 100).toFixed(2)
//                 let totdiscount = parseFloat(discamt) + parseFloat(Addidiscamt);
//                 let grate = (rate - totdiscount).toFixed(2);
//                 let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
//                 const taxableamount = (quantity * salerate).toFixed(2);
//                 const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

//                 let cgst = 0;
//                 let sgst = 0;
//                 let igst = 0;

//                 if (!formData.GSTNumber) {
//                     cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
//                     sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
//                 } else {
//                     const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

//                     if (gstNumberPrefix !== branchstate) {
//                         igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
//                     } else {
//                         cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
//                         sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
//                     }
//                 }

//                 const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

//                 return {
//                     ...item,
//                     Amount: amount,
//                     AdditionalDiscountAmount: parseFloat(Addidiscamt * quantity).toFixed(2),
//                     AdditionalDiscountPercentage: parseFloat(AdditionalDisc).toFixed(2),
//                     DiscountAmount: parseFloat(discamt * quantity).toFixed(2),
//                     TaxableAmount: parseFloat(taxableamount).toFixed(2),
//                     CGSTAmount: parseFloat(cgst).toFixed(2),
//                     SGSTAmount: parseFloat(sgst).toFixed(2),
//                     IGSTAmount: parseFloat(igst).toFixed(2),
//                     TotalAmount: parseFloat(totalAmount).toFixed(2),
//                 };
//             });

//             setInvoicedeatils(updatedItemData);

//             const Quantity = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
//             const Amount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
//             const DiscountAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
//             const TaxableAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
//             const CGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
//             const SGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
//             const IGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
//             const TotalAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);
//             const gvAmount = parseFloat(formData.GVAmount) || 0;
//             const CardAmount = parseFloat(formData.CardAmount) || 0;
//             totalCalculation(Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvAmount, CardAmount, upiAmount);

//         }
//         else {

//             setFormData((prevData) => ({
//                 ...prevData,
//                 [name]: type === 'checkbox' ? checked : value,
//             }));

//         }

//     };

//     const handleSubmit = (event) => {
//         event.preventDefault();
//         setIsLoading(true);

//         if (!formData.CustomerName) {
//             setErrorMessage('Customer Name is required !');
//             setIsLoading(false);
//             return;
//         }

//         if (!formData.SaleBillNumber) {
//             setErrorMessage('Sale Bill Number is required !');
//             setIsLoading(false);
//             return;
//         }


//         // Cash amount validation
//         if (formData.CashAmount < 0) {
//             setErrorMessage('Cash Amount less than 0 is not allowed!');
//             setIsLoading(false);
//             return;
//         }

//         // Card amount validation
//         if (formData.CardAmount > 0) {
//             if (!formData.CardNumber) {
//                 setErrorMessage('Card Number is required when Card Amount is greater than 0!');
//                 setIsLoading(false);
//                 return;
//             }
//             if (!selectedCardType) {
//                 setErrorMessage('Card Type is required when Card Amount is greater than 0!');
//                 setIsLoading(false);
//                 return;
//             }
//         }

//         if (!selectedSalesMan) {
//             setErrorMessage('Sales Man is required !');
//             setIsLoading(false);
//             return;
//         }

//         // Upi amount validation
//         if (formData.UPIAmount > 0) {
//             if (!formData.UPINumber) {
//                 setErrorMessage('UPI Number is required when UPI Amount is greater than 0!');
//                 setIsLoading(false);
//                 return;
//             }
//         }


//         if (!invoicedeatils || invoicedeatils.length === 0) {
//             setErrorMessage('Item Details are required!');
//             setIsLoading(false);
//             return;
//         }

//         setFormData(prevData => ({
//             ...prevData,
//             ModifiedBy: userId,
//             BranchId: branchId,
//             CompanyId: companyId,
//             SalesManId: selectedSalesMan,
//             CardType: selectedCardType
//         }));

//         const CreateData = {
//             Sale: formData,
//             SaleDetails: invoicedeatils
//         };

//         // Validate form data here if needed

//         updateData('SaleReturnApi', `${id}`, CreateData, token)
//             .then((response) => {
//                 console.log('Record updated successfully:', response.data);


//                 if (response.response === 'Sale Return Updated Successfully') {
//                     const SaleId = response.kotId;
//                     handlePrint(SaleId);
//                 }
//                 history.push('/SaleReturnIndex');
//             })
//             .catch((error) => {
//                 console.error('Error updating record:', error);
//             });
//     };

//     const handlePrint = async (SaleId) => {
//         try {

//             const response = await fetchData('SaleReturnApi', `/SalePrint/${SaleId}/${branchId}`, token);
//             const labelData = response.response_data;
//             const labelsToPrint = Array.isArray(labelData) ? labelData : [labelData];

//             const iframe = document.createElement('iframe');
//             iframe.style.display = 'none';
//             document.body.appendChild(iframe);

//             const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
//             iframeDocument.write('<html><head><style>@media print { header, footer { display: none !important; } }</style></head><body>');

//             ReactDOM.render(
//                 <BillPrint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />,
//                 iframeDocument.body
//             );

//             iframeDocument.write('</body></html>');
//             iframeDocument.close();
//             // iframe.contentWindow.print();
//             setTimeout(() => {
//                 iframe.contentWindow.print();
//             }, 1000);

//         } catch (error) {
//             console.error('Error printing Invoice:', error);
//         }
//     };

//     const removeRecord = (index) => {
//         const isConfirmed = window.confirm("Are you sure you want to remove the record?");
//         if (isConfirmed) {
//             const updatedRecords = [...invoicedeatils];
//             updatedRecords.splice(index, 1); // Remove the record at the specified index
//             setInvoicedeatils(updatedRecords); // Update the state to reflect the removed record

//             const Quantity = updatedRecords.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
//             const Amount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
//             const DiscountAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
//             const TaxableAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
//             const CGSTAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
//             const SGSTAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
//             const IGSTAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
//             const TotalAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);

//             const gvAmount = parseFloat(formData.GVAmount) || 0;
//             const CardAmount = parseFloat(formData.CardAmount) || 0;
//             const UPIAmount = parseFloat(formData.UPIAmount) || 0;
//             totalCalculation(Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvAmount, CardAmount, UPIAmount);

//         }

//     };

//     //Items
//     const [itemsOptions, setItemsrOptions] = useState([]);
//     const [selectedItems, setSelectedItem] = useState("");

//     useEffect(() => {
//         fetchItems();
//     }, []);

//     const fetchItems = async () => {
//         try {
//             const response = await fetchData('SaleReturnApi', `/Item/${companyId}/${branchId}`, token);
//             if (response.responseCode === '1111') {

//                 // const options = response.response_data.map(item => ({
//                 //     value: item.Id,
//                 //     label: item.Code + '-' + item.Name
//                 // }));
//                 // setItemsrOptions(options);
//                 setItemDetails(response.response_data);
//             }

//             setFormData(prevData => ({
//                 ...prevData,
//                 BranchId: branchId,
//                 CompanyId: companyId,
//                 CreatedBy: userId,
//             }));

//         } catch (error) {
//             console.error('Error fetching route:', error);
//         }
//     };

//     // FOR MODEL DATA (Invoice Details)
//     const [modalData, setModalData] = useState({
//         SlNo: '0',
//         ItemName: '',
//         ItemId: '',
//         Quantity: '1',
//         Rate: '',
//         Amount: '',
//         DiscountPercentage: '',
//         DiscountAmount: '',
//         HSNCode: '',
//         GSTRate: '',
//         TaxableAmount: '',
//         CGSTAmount: '',
//         SGSTAmount: '',
//         IGSTAmount: '',
//         TotalAmount: '',
//         balanceStock: 0,
//     });

//     const closeModal = () => {
//         setModalData({
//             SlNo: '0',
//             ItemName: '',
//             ItemId: '',
//             Quantity: '1',
//             Rate: '',
//             Amount: '',
//             DiscountPercentage: '',
//             DiscountAmount: '',
//             HSNCode: '',
//             GSTRate: '',
//             TaxableAmount: '',
//             CGSTAmount: '',
//             SGSTAmount: '',
//             IGSTAmount: '',
//             TotalAmount: '',
//             balanceStock: 0,
//         });
//         setSelectedItem();
//         setIsModalOpen(false);
//     };

//     const saveModalData = () => {
//         let isValid = true;
//         let errors = "";
//         setErrorMessageModel(errors);

//         // Validation for ItemId
//         if (!modalData.ItemId) {
//             isValid = false;
//             errors = "Item is required";
//         }

//         // Validation for Quantity
//         if (!modalData.Quantity || isNaN(modalData.Quantity)) {
//             isValid = false;
//             errors = "Quantity must be a valid number";
//         }

//         // if (modalData.Quantity > modalData.balanceStock) {
//         //     isValid = false;
//         //     errors = "Quantity exceeds available stock.";
//         // }


//         if (isValid) {
//             //setInvoicedeatils([...invoicedeatils, modalData]);
//             const updatedInvoicedetails = [...invoicedeatils, modalData];
//             const updatedInvoicedetailsSorted = updatedInvoicedetails.reverse();
//             setInvoicedeatils(updatedInvoicedetailsSorted);

//             setModalData({
//                 ...modalData,
//                 SlNo: '0',
//                 ItemName: '',
//                 ItemId: '',
//                 Quantity: '1',
//                 Rate: '',
//                 Amount: '',
//                 DiscountPercentage: '',
//                 DiscountAmount: '',
//                 HSNCode: '',
//                 GSTRate: '',
//                 TaxableAmount: '',
//                 CGSTAmount: '',
//                 SGSTAmount: '',
//                 IGSTAmount: '',
//                 TotalAmount: '',
//                 balanceStock: 0,
//             });

//             setSelectedItem(0);
//             //closeModal();

//             // Update the totals based on the updatedItemData
//             const Quantity = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
//             const Amount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
//             const DiscountAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
//             const TaxableAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
//             const CGSTAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
//             const SGSTAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
//             const IGSTAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
//             const TotalAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);

//             const gvAmount = parseFloat(formData.GVAmount) || 0;
//             const CardAmount = parseFloat(formData.CardAmount) || 0;
//             const UPIAmount = parseFloat(formData.UPIAmount) || 0;
//             totalCalculation(Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvAmount, CardAmount, UPIAmount);


//         } else {

//             console.log("Validation errors:", errors);
//             setErrorMessageModel(errors);
//         }

//     };

//     const totalCalculation = (Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvamt, CardAmount, UPIAmount) => {

//         const gvAmount = parseFloat(gvamt) || 0;

//         let netamount = parseFloat(TaxableAmount);
//         let netAmt = netamount + parseFloat(CGSTAmount) + parseFloat(SGSTAmount) + parseFloat(IGSTAmount);
//         let roundOffValue = Math.round(netAmt) - netAmt;
//         let totalAmt = parseFloat((netAmt + roundOffValue)).toFixed(2);
//         totalAmt = parseFloat(totalAmt - gvAmount).toFixed(2);
//         let cashamt = parseFloat(totalAmt - CardAmount - UPIAmount).toFixed(2);

//         setFormData((prevData) => ({
//             ...prevData,
//             TotalQuantity: Quantity,
//             TotalAmount: Amount.toFixed(2),
//             DiscountAmount: DiscountAmount.toFixed(2),
//             TaxableAmount: TaxableAmount.toFixed(2),
//             CGSTAmount: CGSTAmount.toFixed(2),
//             SGSTAmount: SGSTAmount.toFixed(2),
//             IGSTAmount: IGSTAmount.toFixed(2),
//             RoundOff: roundOffValue.toFixed(2),
//             GrandTotal: parseFloat(totalAmt).toFixed(2),
//             CashAmount: parseFloat(cashamt).toFixed(2),
//             GVAmount: gvAmount.toFixed(2),
//             CardAmount: CardAmount.toFixed(2),
//             UPIAmount: UPIAmount.toFixed(2),
//             CashDiscount: 0,
//             ModifiedBy: userId,
//         }));
//     };

//     const [itemdetails, setItemDetails] = useState([]);
//     const handleItemSelect = (selectedOption) => {
//         setSelectedItem(selectedOption);
//         setModalData({
//             ...modalData,
//             ItemName: selectedOption ? selectedOption.label : '',
//             ItemId: selectedOption ? selectedOption.value : '',
//         });

//         // Use Array.prototype.find() to find the rate
//         const selectedItemId = selectedOption ? selectedOption.value : '';


//         const selectedItemDetail = itemdetails.find((itemDetail) => itemDetail.Id === selectedItemId);

//         if (selectedItemDetail) {

//             let quantity = parseFloat(modalData.Quantity) || 0;;
//             let rate = parseFloat(selectedItemDetail.MRP.toFixed(2)) || 0;
//             let gstrate = parseFloat(selectedItemDetail.GSTRate.toFixed(2)) || 0;
//             let discountPercentage = parseFloat(selectedItemDetail.DiscountPercentage.toFixed(2)) || 0;

//             let amount = (quantity * rate).toFixed(2);
//             let discamt = ((rate * discountPercentage) / 100).toFixed(2)
//             let grate = (rate - discamt).toFixed(2);
//             let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
//             const taxableamount = (quantity * salerate).toFixed(2);
//             const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

//             let cgst = 0;
//             let sgst = 0;
//             let igst = 0;

//             if (!formData.GSTNumber) {
//                 cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
//                 sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
//             } else {
//                 const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

//                 if (gstNumberPrefix !== branchstate) {
//                     igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
//                 } else {
//                     cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
//                     sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
//                 }
//             }

//             const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

//             setModalData({
//                 ...modalData,
//                 Rate: selectedItemDetail.MRP.toFixed(2), // Assuming Rate is a number
//                 GSTRate: selectedItemDetail.GSTRate.toFixed(2),
//                 HSNCode: selectedItemDetail.HSNCode,
//                 DiscountPercentage: selectedItemDetail.DiscountPercentage.toFixed(2),
//                 ItemName: selectedOption ? selectedOption.label : '',
//                 ItemId: selectedOption ? selectedOption.value : '',
//                 Amount: amount,
//                 DiscountAmount: parseFloat(discamt).toFixed(2),
//                 TaxableAmount: parseFloat(taxableamount).toFixed(2),
//                 CGSTAmount: parseFloat(cgst).toFixed(2),
//                 SGSTAmount: parseFloat(sgst).toFixed(2),
//                 IGSTAmount: parseFloat(igst).toFixed(2),
//                 TotalAmount: parseFloat(totalAmount).toFixed(2),
//                 balanceStock: selectedItemDetail.balanceStock,
//             });

//         } else {
//             // Handle the case where the item detail is not found
//             setModalData({
//                 ...modalData,
//                 Rate: '0.00',
//                 GSTRate: '0.00',
//                 ItemName: selectedOption ? selectedOption.label : '',
//                 ItemId: selectedOption ? selectedOption.value : '',
//                 GSTRate: '0',
//                 HSNCode: '',
//                 DiscountPercentage: '',
//             });
//         }
//     };

//     const [isValid, setIsValid] = useState(true);
//     const handleModalInputChange = (e) => {
//         const { name, value } = e.target;
//         setModalData({
//             ...modalData,
//             [name]: value,
//         });

//         const intValue = parseInt(value, 10);

//         if (intValue > modalData.balanceStock) {
//             setIsValid(false);
//         } else {
//             setIsValid(true);
//         }

//         let quantity = parseFloat(value) || 0;
//         let rate = parseFloat(modalData.Rate) || 0;
//         let gstrate = parseFloat(modalData.GSTRate) || 0;
//         let discountPercentage = parseFloat(modalData.DiscountPercentage) || 0;

//         let amount = (quantity * rate).toFixed(2);
//         let discamt = ((rate * discountPercentage) / 100).toFixed(2)
//         let grate = (rate - discamt).toFixed(2);
//         let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
//         const taxableamount = (quantity * salerate).toFixed(2);
//         const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

//         let cgst = 0;
//         let sgst = 0;
//         let igst = 0;

//         if (!formData.GSTNumber) {
//             cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
//             sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
//         } else {
//             const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

//             if (gstNumberPrefix !== branchstate) {
//                 igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
//             } else {
//                 cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
//                 sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
//             }
//         }

//         const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

//         setModalData({
//             ...modalData,
//             Quantity: quantity,
//             Amount: amount,
//             DiscountAmount: parseFloat(discamt).toFixed(2),
//             TaxableAmount: parseFloat(taxableamount).toFixed(2),
//             CGSTAmount: parseFloat(cgst).toFixed(2),
//             SGSTAmount: parseFloat(sgst).toFixed(2),
//             IGSTAmount: parseFloat(igst).toFixed(2),
//             TotalAmount: parseFloat(totalAmount).toFixed(2),
//         });
//     };

//     const [isModalOpen, setIsModalOpen] = useState(false);

//     const toggleModal = () => {
//         setIsModalOpen(!isModalOpen);
//         setSelectedOption(null); // Clear AsyncSelect
//         fetchOptions('');
//     };

//     const formatDateForInput = (dateString) => {
//         const currentDate = new Date(dateString);;
//         const year = currentDate.getFullYear();
//         const month = String(currentDate.getMonth() + 1).padStart(2, '0');
//         const day = String(currentDate.getDate()).padStart(2, '0');
//         const formattedDate = `${year}-${month}-${day}`;

//         return formattedDate;
//     };

//     const [selectedOption, setSelectedOption] = useState(null);
//     const handleInputChange = (newValue) => newValue;

//     const handleChangeDrop = (selectedOption) => {
//         setSelectedOption(selectedOption);
//         const selectedItemDetail = itemdetails.find((itemDetail) => itemDetail.Id === selectedOption.value);
//         if (selectedItemDetail) {

//             let quantity = parseFloat(modalData.Quantity) || 0;;
//             let rate = parseFloat(selectedItemDetail.MRP.toFixed(2)) || 0;
//             let gstrate = parseFloat(selectedItemDetail.GSTRate.toFixed(2)) || 0;
//             let discountPercentage = parseFloat(selectedItemDetail.DiscountPercentage.toFixed(2)) || 0;

//             let amount = (quantity * rate).toFixed(2);
//             let discamt = ((rate * discountPercentage) / 100).toFixed(2)
//             let grate = (rate - discamt).toFixed(2);
//             let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
//             const taxableamount = (quantity * salerate).toFixed(2);
//             const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

//             let cgst = 0;
//             let sgst = 0;
//             let igst = 0;

//             if (!formData.GSTNumber) {
//                 cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
//                 sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
//             } else {
//                 const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

//                 if (gstNumberPrefix !== branchstate) {
//                     igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
//                 } else {
//                     cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
//                     sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
//                 }
//             }

//             const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

//             setModalData({
//                 ...modalData,
//                 Rate: selectedItemDetail.MRP.toFixed(2), // Assuming Rate is a number
//                 GSTRate: selectedItemDetail.GSTRate.toFixed(2),
//                 HSNCode: selectedItemDetail.HSNCode,
//                 DiscountPercentage: selectedItemDetail.DiscountPercentage.toFixed(2),
//                 ItemName: selectedOption ? selectedOption.label : '',
//                 ItemId: selectedOption ? selectedOption.value : '',
//                 Amount: amount,
//                 DiscountAmount: parseFloat(discamt).toFixed(2),
//                 TaxableAmount: parseFloat(taxableamount).toFixed(2),
//                 CGSTAmount: parseFloat(cgst).toFixed(2),
//                 SGSTAmount: parseFloat(sgst).toFixed(2),
//                 IGSTAmount: parseFloat(igst).toFixed(2),
//                 TotalAmount: parseFloat(totalAmount).toFixed(2),
//                 balanceStock: selectedItemDetail.balanceStock,
//             });
//         }
//     };

//     return (
//         <Fragment>
//             <div className="w-full max-w-sm container mt-2 mx-auto" style={{ maxWidth: '100%' }}>

//                 <style>
//                     {`
//                         /* Hide scrollbar for Chrome, Safari, and Opera */
//                         .container::-webkit-scrollbar {
//                         width: 0.2em;
//                         }

//                         .container::-webkit-scrollbar-track {
//                         background: rgba(255,255,255,0);
//                         }

//                         .container::-webkit-scrollbar-thumb {
//                         background-color: rgba(255,255,255,0);
//                         border-radius: 4px;
//                         }
//                     `}
//                 </style>

//                 <div className="w-full mb-2 flex">
//                     <h6 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}> Sale Return - Edit</h6>

//                     {/* {roleName == "SuperAdmin" && (
//                         <Button className="bg-blue-500 text-white px-4 py-2 rounded" onClick={toggleModal}>
//                             <AddIcon style={{ color: 'darkmagenta', fontWeight: 'bolder' }} /> <span style={{ color: 'darkmagenta', fontWeight: 'bolder' }}> Add Item</span>
//                         </Button>
//                     )} */}

//                     <Button
//                         style={{ marginLeft: '8px', color: 'darkgreen' }}
//                         onClick={handleSubmit}
//                         disabled={isLoading}
//                     >
//                         <DoneAllIcon style={{ color: 'darkgreen', fontWeight: 'bolder' }} /> {isLoading ? <CircularProgress size={24} color="inherit" /> : <b>Update</b>}
//                     </Button>

//                     <Button
//                         component={Link}
//                         to="/SaleReturnIndex"
//                         className="linkcolor"
//                         style={{ marginLeft: '8px', color: 'darkred', fontWeight: 'bolder' }}
//                     >
//                         <ArrowCircleLeftIcon style={{ color: 'darkred', fontWeight: 'bolder' }} /> Back to List
//                     </Button>

//                 </div>

//                 <div className="watermark">
//                     <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
//                 </div>
//                 {errorMessage && <p className="text-red-500">{errorMessage}</p>}
//                 {successMessage && <p className="text-green-500">{successMessage}</p>}

//                 <div className="w-full mb-4 flex" style={{ marginTop: '-1%' }}>
//                     <div className="container mx-auto mt-2 p-4 max-w-screen-md bg-tabcolor rounded-lg shadow-lg p-6" style={{ marginTop: '10px', backgroundColor: 'rgba(255, 255, 255, 0.5)', maxHeight: '500px', overflowY: 'auto', width: '100%', maxWidth: '100%' }}>

//                         <div className="w-full mb-2 flex" style={{ marginTop: '-1.20%' }}>

//                             <div className="w-3/4 mr-2">
//                                 <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
//                                     Customer Name
//                                     <span className="text-red-500">*</span>
//                                 </label>
//                                 <input
//                                     className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
//                                     value={formData.CustomerName}
//                                     onChange={handleChange}
//                                     type="text"
//                                     placeholder="CUSTOMER NAME"
//                                     name='CustomerName'
//                                 />
//                             </div>

//                             {roleName !== "SuperAdmin" ? (
//                                 <div className="w-1/4 mr-2">
//                                     <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
//                                         Bill Date
//                                         <span className="text-red-500">*</span>
//                                     </label>
//                                     <input
//                                         className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
//                                         value={formatDateForInput(formData.BillDate)}
//                                         onChange={handleChange}
//                                         type="date"
//                                         name='BillDate'
//                                         readOnly
//                                     />
//                                 </div>

//                             ) : (

//                                 <div className="w-1/4 mr-2">
//                                     <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
//                                         Bill Date
//                                         <span className="text-red-500">*</span>
//                                     </label>
//                                     <input
//                                         className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
//                                         value={formatDateForInput(formData.BillDate)}
//                                         onChange={handleChange}
//                                         type="date"
//                                         name='BillDate'
//                                     />
//                                 </div>
//                             )}

//                             {roleName !== "SuperAdmin" ? (
//                                 <div className="w-1/4 mr-2">
//                                     <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
//                                         Bill Number
//                                         <span className="text-red-500">*</span>
//                                     </label>
//                                     <input
//                                         className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
//                                         value={formData.BillNumber}
//                                         onChange={handleChange}
//                                         type="text"
//                                         placeholder="BILL NUMBER"
//                                         name='BillNumber'
//                                         readOnly
//                                     />
//                                 </div>
//                             ) : (
//                                 <div className="w-1/4 mr-2">
//                                     <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
//                                         Bill Number
//                                         <span className="text-red-500">*</span>
//                                     </label>
//                                     <input
//                                         className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
//                                         value={formData.BillNumber}
//                                         onChange={handleChange}
//                                         type="text"
//                                         placeholder="BILL NUMBER"
//                                         name='BillNumber'
//                                     />
//                                 </div>
//                             )}

//                             <div className="w-1/4 mr-2">
//                                 <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
//                                     Total Quantity
//                                     <span className="text-red-500">*</span>
//                                 </label>
//                                 <input
//                                     className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
//                                     value={formData.TotalQuantity}
//                                     onChange={handleChange}
//                                     type="text"
//                                     placeholder="TOTAL QUANTITY"
//                                     name='TotalQuantity'
//                                     readOnly
//                                 />
//                             </div>

//                             <div className="w-1/4 mr-2">
//                                 <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
//                                     Addt'l. Disc %
//                                     <span className="text-red-500">*</span>
//                                 </label>
//                                 <input
//                                     className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
//                                     value={formData.AdditionalDiscountPercentage}
//                                     onChange={handleChange}
//                                     type="number"
//                                     placeholder="Disc %"
//                                     style={{ textAlign: 'right' }}
//                                     name='AdditionalDiscountPercentage'
//                                 />
//                             </div>

//                         </div>

//                         <div className="w-full mb-4 flex" style={{ marginTop: '-0.30%' }}>
//                             <div className="w-3/4 mr-2">
//                                 <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
//                                     Address
//                                 </label>
//                                 <input
//                                     className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
//                                     value={formData.CustomerAddress}
//                                     onChange={handleChange}
//                                     type="text"
//                                     placeholder="Address"
//                                     name='CustomerAddress'
//                                 />
//                             </div>

//                             <div className="w-1/4 mr-2">
//                                 <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
//                                     GST Number
//                                 </label>
//                                 <input
//                                     className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
//                                     value={formData.GSTNumber}
//                                     onChange={handleChange}
//                                     type="text"
//                                     placeholder="GST Number"
//                                     name='GSTNumber'
//                                 />
//                             </div>

//                             {roleName !== "SuperAdmin" ? (
//                                 <div className="w-1/4 mr-2">
//                                     <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
//                                         Sale Bill No
//                                         <span className="text-red-500">*</span>
//                                     </label>
//                                     <input
//                                         className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
//                                         value={formData.SaleBillNumber}
//                                         onChange={handleChange}
//                                         type="text"
//                                         placeholder="Sale Bill Number"
//                                         name='SaleBillNumber'
//                                         readOnly
//                                     />
//                                 </div>
//                             ) : (
//                                 <div className="w-1/4 mr-2">
//                                     <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
//                                         Sale Bill No
//                                         <span className="text-red-500">*</span>
//                                     </label>
//                                     <input
//                                         className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
//                                         value={formData.SaleBillNumber}
//                                         onChange={handleChange}
//                                         type="text"
//                                         placeholder="Sale Bill Number"
//                                         name='SaleBillNumber'
//                                     />
//                                 </div>
//                             )}

//                             {roleName !== "SuperAdmin" ? (
//                                 <div className="w-1/4 mr-2">
//                                     <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
//                                         Sale Bill Date
//                                         <span className="text-red-500">*</span>
//                                     </label>
//                                     <input
//                                         className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
//                                         value={formatDateForInput(formData.SaleBillDate)}
//                                         onChange={handleChange}
//                                         type="date"
//                                         name='SaleBillDate'
//                                         readOnly
//                                     />
//                                 </div>
//                             ) : (
//                                 <div className="w-1/4 mr-2">
//                                     <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
//                                         Sale Bill Date
//                                         <span className="text-red-500">*</span>
//                                     </label>
//                                     <input
//                                         className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
//                                         value={formatDateForInput(formData.SaleBillDate)}
//                                         onChange={handleChange}
//                                         type="date"
//                                         name='SaleBillDate'
//                                     />
//                                 </div>
//                             )}

//                             <div className="w-1/4 mr-2">
//                                 <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
//                                     Sales Man
//                                     <span className="text-red-500">*</span>
//                                 </label>
//                                 <select
//                                     className={`custom-select ${selectedSalesMan ? 'fade-in' : 'fade-in'}`}
//                                     style={{ height: '30px', fontSize: '12px' }} // Direct height control
//                                     value={selectedSalesMan}
//                                     // onChange={(e) => setSelectedSalesMan(e.target.value)}
//                                     onChange={(e) => {
//                                         const selectedValue = e.target.value;
//                                         setSelectedSalesMan(selectedValue);
//                                         setFormData((prevFormData) => ({
//                                             ...prevFormData,
//                                             SalesManId: selectedValue,
//                                         }));
//                                     }}
//                                 >
//                                     <option value="">Select Sales Man</option>
//                                     {dropdownSalesManOptions.map((category) => (
//                                         <option key={category.Id} value={category.Id}>
//                                             {category.Name}
//                                         </option>
//                                     ))}
//                                 </select>

//                             </div>

//                         </div>
//                         <div className="w-full mb-2 flex" style={{ marginTop: '-1.50%' }}>
//                             {/* Item Name */}
//                             <div className="w-1/2 mr-2">
//                                 <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="Weightage" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
//                                     Item Name
//                                 </label>
//                                 <AsyncSelect
//                                     cacheOptions
//                                     loadOptions={fetchOptions}
//                                     onInputChange={handleInputChange}
//                                     onChange={handleChangeDrop}
//                                     value={selectedOption}
//                                     isSearchable
//                                     styles={{
//                                         control: (provided) => ({
//                                             ...provided,
//                                             minHeight: '30px',
//                                             height: '30px',
//                                             marginTop: '5px',
//                                         }),
//                                         valueContainer: (provided) => ({
//                                             ...provided,
//                                             height: '30px',
//                                             padding: '0 6px',
//                                         }),
//                                         input: (provided) => ({
//                                             ...provided,
//                                             margin: 0,
//                                             padding: 0,
//                                         }),
//                                         indicatorsContainer: (provided) => ({
//                                             ...provided,
//                                             height: '30px',
//                                         }),
//                                         menuPortal: (provided) => ({
//                                             ...provided,
//                                             zIndex: 9999, // Ensures dropdown is above everything
//                                         }),
//                                     }}
//                                     menuPortalTarget={document.body} // Required for zIndex to work
//                                 />
//                             </div>

//                             {/* Quantity */}
//                             <div className="w-1/7 mr-2">
//                                 <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="MinimumStock" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
//                                     Quantity
//                                 </label>
//                                 <input
//                                     className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right h-8"
//                                     type="number"
//                                     name="Quantity"
//                                     placeholder="Quantity"
//                                     value={modalData.Quantity}
//                                     onChange={handleModalInputChange}
//                                     max={modalData.balanceStock}
//                                     min={1}
//                                 />
//                                 {!isValid && (
//                                     <p className="text-red-500 text-xs italic">
//                                         Quantity exceeds available stock.
//                                     </p>
//                                 )}
//                             </div>

//                             <button
//                                 className="bg-green-500 hover:bg-green-600 text-white text-xs font-semibold px-3 py-1 rounded-full shadow-md transition duration-200"
//                                 onClick={saveModalData}
//                                 style={{ marginLeft: '10px', marginTop: '25px', width: '80px', height: '30px', cursor: 'pointer' }}
//                             >
//                                 Add
//                             </button>

//                         </div>
//                         <div className="w-full mb-2 flex" style={{ marginTop: '-0.20%' }}>
//                             <div className="w-full mb-2 flex">
//                                 <TableContainer component={Paper}>
//                                     <table className="table">
//                                         <thead>
//                                             <tr style={{ backgroundColor: '#A1D6B2' }}>
//                                                 <th style={{ padding: '2px', backgroundColor: '#27445D', textTransform: 'uppercase', fontSize: '13px', color: 'white', fontFamily: 'monospace' }}>Item Name</th>
//                                                 <th style={{ padding: '2px', backgroundColor: '#27445D', textTransform: 'uppercase', fontSize: '13px', textAlign: 'center', color: 'white', fontFamily: 'monospace' }}>Quantity</th>
//                                                 <th style={{ padding: '2px', backgroundColor: '#27445D', textTransform: 'uppercase', fontSize: '13px', textAlign: 'right', color: 'white', fontFamily: 'monospace' }}>MRP</th>
//                                                 <th style={{ padding: '2px', backgroundColor: '#27445D', textTransform: 'uppercase', fontSize: '13px', textAlign: 'right', color: 'white', fontFamily: 'monospace' }}>DISC %</th>
//                                                 <th style={{ padding: '2px', backgroundColor: '#27445D', textTransform: 'uppercase', fontSize: '13px', textAlign: 'right', color: 'white', fontFamily: 'monospace' }}>Amount</th>
//                                                 {roleName == "SuperAdmin" && (
//                                                     <th style={{ padding: '2px', backgroundColor: '#27445D', textTransform: 'uppercase', fontSize: '13px', textAlign: 'right', color: 'white', fontFamily: 'monospace' }}>Action</th>
//                                                 )}
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {invoicedeatils.map((invdetail, index) => (
//                                                 <tr key={index} className={invdetail.ColorCode === '#ffffff' ? 'white-row' : ''} style={{ width: '100%' }}>
//                                                     <td style={{ padding: '2px', borderBottom: '1px solid black', borderRight: '1px solid grey', fontSize: '12px', fontWeight: 'bold', width: '45%' }}>{invdetail.ItemName}</td>
//                                                     <td style={{ padding: '2px', borderBottom: '1px solid black', borderRight: '1px solid grey', fontSize: '12px', fontWeight: 'bold', width: '10%', textAlign: 'center' }}>{invdetail.Quantity}</td>
//                                                     <td style={{ padding: '2px', borderBottom: '1px solid black', borderRight: '1px solid grey', fontSize: '12px', fontWeight: 'bold', width: '10%', textAlign: 'right' }}>{invdetail.Rate}</td>
//                                                     <td style={{ padding: '2px', borderBottom: '1px solid black', borderRight: '1px solid grey', fontSize: '12px', fontWeight: 'bold', width: '10%', textAlign: 'right' }}>{invdetail.DiscountPercentage}</td>
//                                                     <td style={{ padding: '2px', borderBottom: '1px solid black', borderRight: '1px solid grey', fontSize: '12px', fontWeight: 'bold', width: '15%', textAlign: 'right' }}>{invdetail.TotalAmount}</td>

//                                                     {roleName == "SuperAdmin" && (
//                                                         <td style={{ padding: '2px', borderBottom: '1px solid black', borderRight: '1px solid grey', marginTop: '-15px', width: '10%', textAlign: 'right' }}>
//                                                             <IconButton style={{ padding: '8px', marginTop: '-10px' }} onClick={() => removeRecord(index)}>
//                                                                 <DeleteIcon style={{ color: '#CD5656', fontSize: '19px' }} />
//                                                             </IconButton>
//                                                         </td>
//                                                     )}
//                                                 </tr>
//                                             ))}
//                                         </tbody>
//                                     </table>
//                                 </TableContainer>

//                             </div>
//                         </div>

//                         <div className="w-full mb-2 flex" style={{ marginTop: '-0.80%' }}>

//                             <div className="w-3/4 mr-2">
//                                 <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
//                                     Remarks
//                                 </label>
//                                 <input
//                                     className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
//                                     value={formData.Remarks}
//                                     onChange={handleChange}
//                                     type="text"
//                                     placeholder="Remarks"
//                                     name='Remarks'
//                                 />
//                             </div>

//                             <div className="w-1/4 mr-2">
//                                 <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
//                                     Amount
//                                 </label>
//                                 <input
//                                     className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"

//                                     value={formData.TotalAmount}
//                                     onChange={handleChange}
//                                     type="text"
//                                     placeholder="Amount"
//                                     style={{ textAlign: 'right', fontWeight: 'bold' }}
//                                     name='TotalAmount'
//                                     readOnly
//                                 />
//                             </div>

//                             <div className="w-1/4 mr-2">
//                                 <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
//                                     Discount
//                                 </label>
//                                 <input
//                                     className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"

//                                     value={formData.DiscountAmount}
//                                     onChange={handleChange}
//                                     type="text"
//                                     placeholder="Discount"
//                                     style={{ textAlign: 'right', fontWeight: 'bold' }}
//                                     name='DiscountAmount'
//                                     readOnly
//                                 />
//                             </div>

//                             <div className="w-1/4 mr-2">
//                                 <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
//                                     Cash Disc
//                                 </label>
//                                 <input
//                                     className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"

//                                     value={formData.CashDiscount}
//                                     onChange={handleChange}
//                                     type="text"
//                                     placeholder="Cash Discount"
//                                     style={{ textAlign: 'right', fontWeight: 'bold' }}
//                                     name='CashDiscount'
//                                     readOnly
//                                 />
//                             </div>

//                             <div className="w-1/4 mr-2">
//                                 <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
//                                     GV Amount
//                                 </label>
//                                 <input
//                                     className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"

//                                     value={formData.GVAmount}
//                                     onChange={handleChange}
//                                     type="text"
//                                     placeholder="GV Amount"
//                                     style={{ textAlign: 'right', fontWeight: 'bold' }}
//                                     name='GVAmount'
//                                 />
//                             </div>

//                             <div className="w-1/4 mr-2">
//                                 <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
//                                     Net Amount
//                                 </label>
//                                 <input
//                                     className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"

//                                     value={formData.TaxableAmount}
//                                     onChange={handleChange}
//                                     type="text"
//                                     placeholder="Net Amount"
//                                     name='TaxableAmount'
//                                     readOnly
//                                     style={{ textAlign: 'right', fontWeight: 'bold' }}
//                                 />
//                             </div>

//                         </div>

//                         <div className="w-full mb-2 flex">
//                             <div className="w-1/4 mr-2">
//                                 <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
//                                     CGST
//                                 </label>
//                                 <input
//                                     className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"

//                                     value={formData.CGSTAmount}
//                                     onChange={handleChange}
//                                     type="text"
//                                     placeholder="CGST"
//                                     name='CGSTAmount'
//                                     readOnly
//                                     style={{ textAlign: 'right', fontWeight: 'bold' }}
//                                 />
//                             </div>

//                             <div className="w-1/4 mr-2">
//                                 <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
//                                     SGST
//                                 </label>
//                                 <input
//                                     className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"

//                                     value={formData.SGSTAmount}
//                                     onChange={handleChange}
//                                     type="text"
//                                     placeholder="SGST"
//                                     name='SGSTAmount'
//                                     readOnly
//                                     style={{ textAlign: 'right', fontWeight: 'bold' }}
//                                 />
//                             </div>

//                             <div className="w-1/4 mr-2">
//                                 <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
//                                     IGST
//                                 </label>
//                                 <input
//                                     className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"

//                                     value={formData.IGSTAmount}
//                                     onChange={handleChange}
//                                     type="text"
//                                     placeholder="IGST"
//                                     name='IGSTAmount'
//                                     readOnly
//                                     style={{ textAlign: 'right', fontWeight: 'bold' }}
//                                 />
//                             </div>

//                             <div className="w-1/4 mr-2">
//                                 <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
//                                     Round Off
//                                 </label>
//                                 <input
//                                     className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
//                                     value={formData.RoundOff}
//                                     onChange={handleChange}
//                                     type="text"
//                                     placeholder="Round Off"
//                                     name='RoundOff'
//                                     readOnly
//                                     style={{ textAlign: 'right', fontWeight: 'bold' }}
//                                 />
//                             </div>

//                             <div className="w-1/4 mr-2">
//                                 <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
//                                     Total
//                                 </label>
//                                 <input
//                                     className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"

//                                     value={formData.GrandTotal}
//                                     onChange={handleChange}
//                                     type="text"
//                                     placeholder="Grand Total"
//                                     name='GrandTotal'
//                                     readOnly
//                                     style={{ textAlign: 'right', fontWeight: 'bold' }}
//                                 />
//                             </div>

//                             <div className="w-1/4 mr-2">
//                                 <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
//                                     Cash
//                                     <span className="text-red-500">*</span>
//                                 </label>
//                                 <input
//                                     className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8 ${formData.CashAmount < 0 ? 'text-red-500' : ''}`}

//                                     value={formData.CashAmount}
//                                     onChange={handleChange}
//                                     type="text"
//                                     placeholder="Cash"
//                                     name='CashAmount'
//                                     style={{ textAlign: 'right', fontWeight: 'bold' }}
//                                     readOnly
//                                 />
//                             </div>

//                             <div className="w-1/4 mr-2">
//                                 <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
//                                     Card
//                                     <span className="text-red-500">*</span>
//                                 </label>
//                                 <input
//                                     className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"

//                                     value={formData.CardAmount}
//                                     onChange={handleChange}
//                                     type="text"
//                                     placeholder="Card"
//                                     name='CardAmount'
//                                     style={{ textAlign: 'right', fontWeight: 'bold' }}
//                                 />
//                             </div>

//                             <div className="w-1/4 mr-2">
//                                 <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
//                                     UPI
//                                     <span className="text-red-500">*</span>
//                                 </label>
//                                 <input
//                                     className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"

//                                     value={formData.UPIAmount}
//                                     onChange={handleChange}
//                                     type="text"
//                                     placeholder="UPI"
//                                     name='UPIAmount'
//                                     style={{ textAlign: 'right', fontWeight: 'bold' }}
//                                 />
//                             </div>

//                         </div>

//                     </div>
//                     {
//                         isModalOpen && (
//                             <div className="w-full mb-4 flex" style={{ marginLeft: '10px', width: '50%', marginTop: '10px' }}>
//                                 <div className="w-full pr-4">
//                                     <div className="bg-teal-800 rounded-lg shadow-lg p-6">
//                                         {errorMessageModel && <p className="text-red-500">{errorMessageModel}</p>}
//                                         <p style={{ color: 'whitesmoke', fontWeight: 'bolder' }}>ADD ITEMS</p>
//                                         <div className="w-full mb-4 flex">
//                                             <div className="w-4/7 mr-3" style={{ marginLeft: '5px', width: '300px' }}>
//                                                 <label className="block uppercase tracking-wide text-white text-xs font-bold mb-2" htmlFor="Weightage">
//                                                     Item Name
//                                                 </label>

//                                                 <AsyncSelect
//                                                     cacheOptions
//                                                     loadOptions={fetchOptions}
//                                                     onInputChange={handleInputChange}
//                                                     onChange={handleChangeDrop}
//                                                     value={selectedOption}
//                                                 />

//                                             </div>
//                                             <div className="w-1/4 mr-3">
//                                                 <label className="block uppercase tracking-wide text-white text-xs font-bold mb-2" htmlFor="MinimumStock">
//                                                     Quantity
//                                                 </label>
//                                                 <input
//                                                     className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
//                                                     type="number"
//                                                     name="Quantity"
//                                                     placeholder="Quantity"
//                                                     value={modalData.Quantity}
//                                                     onChange={handleModalInputChange}
//                                                     min={1}
//                                                 />
//                                                 {!isValid && (
//                                                     <p className="text-red-500 text-xs italic">
//                                                         Quantity exceeds available stock.
//                                                     </p>
//                                                 )}
//                                             </div>
//                                         </div>
//                                         <div className="w-1/2 mr-4" >
//                                             <button className="bg-green-500 text-white px-4 py-2 rounded" onClick={saveModalData}>
//                                                 Add Record
//                                             </button>
//                                         </div>
//                                         <div className="w-1/2 mr-4" style={{ marginLeft: '140px', marginTop: '-40px' }}>
//                                             <button className="bg-blue-500 text-white px-4 py-2 rounded  ml-2" onClick={toggleModal} >
//                                                 Cancel
//                                             </button>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         )
//                     }


//                 </div>


//             </div >
//         </Fragment >

//     );
// };

// export default SaleReturnEdit;



import React, { Fragment, useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData, postData } from '../../../apiService';
import { faL } from '@fortawesome/free-solid-svg-icons';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import CircularProgress from '@mui/material/CircularProgress';
import BillPrint from '../salereturn/Bill';
import ReactDOM from 'react-dom';
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import CopyrightIcon from '@mui/icons-material/Copyright';
import AsyncSelect from 'react-select/async';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import DoneAllIcon from '@mui/icons-material/DoneAll';

const SaleReturnEdit = () => {
    const { id } = useParams();
    const history = useHistory();
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate, roleName } = useAuth();

    const [selectedSalesMan, setSelectedSalesMan] = useState("");
    const [dropdownSalesManOptions, setDropdownSalesManOptions] = useState([]);

    const [selectedCardType, setSelectedCardType] = useState("");
    const [dropdownCardTypeOptions, setDropdownCardTypeOptions] = useState([]);

    const [showCardFields, setShowCardFields] = useState(false);
    const [showupiFields, setShowupiFields] = useState(false);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, branchId, token, logout]);

    useEffect(() => {
        fetchDropdownSalesManOptions();
        fetchDropdownCardTypeOptions();
    }, []);

    // const fetchOptions = async (inputValue) => {
    //     if (inputValue.length <= 4) {
    //         return [];
    //     }

    //     const response = await fetchData('PurchaseApi', `/Item/${companyId}/${branchId}/${inputValue}`, token);
    //     if (response.responseCode === '1111') {
    //         const data = await response.response_data;
    //         return data.map(item => ({
    //             value: item.Id,
    //             label: item.Code + '-' + item.Name,
    //         }));
    //     }
    // };

    const fetchOptions = async (inputValue) => {
        if (inputValue.length < 1) {
            return [];
        }
        const response = await fetchData('PurchaseApi', `/ItemSaleReturn/${companyId}/${id}/${inputValue}`, token);
        if (response.responseCode === '1111') {
            const data = await response.response_data;
            return data.map(item => ({
                value: item.Id,
                label: item.Code + '-' + item.Name,
            }));
        }
    };

    const fetchDropdownSalesManOptions = () => {
        fetchData('SaleReturnApi', `/SalesMan/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownSalesManOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Sales Man dropdown options:', error);
            });
    };

    const fetchDropdownCardTypeOptions = () => {
        fetchData('SaleReturnApi', `/CardType/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownCardTypeOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Card Type dropdown options:', error);
            });
    };

    const hasCreateTransactionPermission = permissions.includes('Create Transaction');
    const hasEditTransactionPermission = permissions.includes('Edit Transaction');
    const hasDeleteTransactionPermission = permissions.includes('Delete Transaction');

    const [formData, setFormData] = useState([]);
    const [invoicedeatils, setInvoicedeatils] = useState([]);

    useEffect(() => {
        fetchData('SaleReturnApi', `/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data.Sale);
                    setInvoicedeatils(response.response_data.SaleDetails);
                    setFormData(prevData => ({
                        ...prevData,
                        UpdatedBy: userId,
                    }));

                    setSelectedSalesMan(response.response_data.Sale.SalesManId);
                    setSelectedCardType(response.response_data.Sale.CardType);
                }
            })
            .catch((error) => {
                console.error('Error fetching Sale Details:', error);
            });
    }, [id]);

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        if (name === 'GVAmount') {
            const gvamt = parseFloat(value) || 0;
            setFormData((prevData) => ({
                ...prevData,
                GVAmount: gvamt.toFixed(2),
                ModifiedBy: userId,
            }));

            const AdditionalDisc = parseFloat(formData.AdditionalDiscountPercentage) || 0;

            const updatedItemData = invoicedeatils.map((item) => {

                let rate = parseFloat(item.Rate) || 0;
                let gstrate = parseFloat(item.GSTRate) || 0;
                let discountPercentage = parseFloat(item.DiscountPercentage) || 0;
                let quantity = parseFloat(item.Quantity) || 0;
                let amount = (quantity * rate).toFixed(2);
                let discamt = ((rate * discountPercentage) / 100).toFixed(2)
                let Addidiscamt = ((rate * AdditionalDisc) / 100).toFixed(2)
                let totdiscount = parseFloat(discamt) + parseFloat(Addidiscamt);
                let grate = (rate - totdiscount).toFixed(2);
                let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
                const taxableamount = (quantity * salerate).toFixed(2);
                const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

                let cgst = 0;
                let sgst = 0;
                let igst = 0;

                if (!formData.GSTNumber) {
                    cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                } else {
                    const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

                    if (gstNumberPrefix !== branchstate) {
                        igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
                    } else {
                        cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                        sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    }
                }

                const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

                return {
                    ...item,
                    Amount: amount,
                    DiscountAmount: parseFloat(discamt * quantity).toFixed(2),
                    AdditionalDiscountAmount: parseFloat(Addidiscamt * quantity).toFixed(2),
                    AdditionalDiscountPercentage: parseFloat(AdditionalDisc).toFixed(2),
                    TaxableAmount: parseFloat(taxableamount).toFixed(2),
                    CGSTAmount: parseFloat(cgst).toFixed(2),
                    SGSTAmount: parseFloat(sgst).toFixed(2),
                    IGSTAmount: parseFloat(igst).toFixed(2),
                    TotalAmount: parseFloat(totalAmount).toFixed(2),
                };
            });

            setInvoicedeatils(updatedItemData);

            const Quantity = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const DiscountAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
            const TaxableAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
            const CGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);

            const CardAmount = parseFloat(formData.CardAmount) || 0;
            const UPIAmount = parseFloat(formData.UPIAmount) || 0;
            totalCalculation(Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvamt, CardAmount, UPIAmount);
        }
        else if (name === 'GSTNumber') {
            const gstno = value;
            setFormData((prevData) => ({
                ...prevData,
                GSTNumber: gstno,
                ModifiedBy: userId,
            }));

            const AdditionalDisc = parseFloat(formData.AdditionalDiscountPercentage) || 0;

            const updatedItemData = invoicedeatils.map((item) => {

                let rate = parseFloat(item.Rate) || 0;
                let gstrate = parseFloat(item.GSTRate) || 0;
                let discountPercentage = parseFloat(item.DiscountPercentage) || 0;
                let quantity = parseFloat(item.Quantity) || 0;
                let amount = (quantity * rate).toFixed(2);
                let discamt = ((rate * discountPercentage) / 100).toFixed(2)
                let Addidiscamt = ((rate * AdditionalDisc) / 100).toFixed(2)
                let totdiscount = parseFloat(discamt) + parseFloat(Addidiscamt);
                let grate = (rate - totdiscount).toFixed(2);
                let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
                const taxableamount = (quantity * salerate).toFixed(2);
                const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

                let cgst = 0;
                let sgst = 0;
                let igst = 0;

                if (!gstno) {
                    cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                } else {
                    const gstNumberPrefix = gstno.toString().substring(0, 2);

                    if (gstNumberPrefix !== branchstate) {
                        igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
                    } else {
                        cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                        sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    }
                }

                const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

                return {
                    ...item,
                    Amount: amount,
                    AdditionalDiscountAmount: parseFloat(Addidiscamt * quantity).toFixed(2),
                    AdditionalDiscountPercentage: parseFloat(AdditionalDisc).toFixed(2),
                    DiscountAmount: parseFloat(discamt * quantity).toFixed(2),
                    TaxableAmount: parseFloat(taxableamount).toFixed(2),
                    CGSTAmount: parseFloat(cgst).toFixed(2),
                    SGSTAmount: parseFloat(sgst).toFixed(2),
                    IGSTAmount: parseFloat(igst).toFixed(2),
                    TotalAmount: parseFloat(totalAmount).toFixed(2),
                };
            });

            setInvoicedeatils(updatedItemData);

            const Quantity = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const DiscountAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
            const TaxableAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
            const CGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);
            const gvAmount = parseFloat(formData.GVAmount) || 0;
            const CardAmount = parseFloat(formData.CardAmount) || 0;
            const UPIAmount = parseFloat(formData.UPIAmount) || 0;
            totalCalculation(Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvAmount, CardAmount, UPIAmount);

        }
        else if (name === 'CardAmount') {

            const cardAmount = parseFloat(value) || 0;
            setFormData((prevData) => ({
                ...prevData,
                CardAmount: cardAmount.toFixed(2),
                ModifiedBy: userId,
            }));
            const AdditionalDisc = parseFloat(formData.AdditionalDiscountPercentage) || 0;
            const updatedItemData = invoicedeatils.map((item) => {

                let rate = parseFloat(item.Rate) || 0;
                let gstrate = parseFloat(item.GSTRate) || 0;
                let discountPercentage = parseFloat(item.DiscountPercentage) || 0;
                let quantity = parseFloat(item.Quantity) || 0;
                let amount = (quantity * rate).toFixed(2);
                let discamt = ((rate * discountPercentage) / 100).toFixed(2)
                let Addidiscamt = ((rate * AdditionalDisc) / 100).toFixed(2)
                let totdiscount = parseFloat(discamt) + parseFloat(Addidiscamt);
                let grate = (rate - totdiscount).toFixed(2);
                let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
                const taxableamount = (quantity * salerate).toFixed(2);
                const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

                let cgst = 0;
                let sgst = 0;
                let igst = 0;

                if (!formData.GSTNumber) {
                    cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                } else {
                    const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

                    if (gstNumberPrefix !== branchstate) {
                        igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
                    } else {
                        cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                        sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    }
                }

                const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

                return {
                    ...item,
                    Amount: amount,
                    AdditionalDiscountAmount: parseFloat(Addidiscamt * quantity).toFixed(2),
                    AdditionalDiscountPercentage: parseFloat(AdditionalDisc).toFixed(2),
                    DiscountAmount: parseFloat(discamt * quantity).toFixed(2),
                    TaxableAmount: parseFloat(taxableamount).toFixed(2),
                    CGSTAmount: parseFloat(cgst).toFixed(2),
                    SGSTAmount: parseFloat(sgst).toFixed(2),
                    IGSTAmount: parseFloat(igst).toFixed(2),
                    TotalAmount: parseFloat(totalAmount).toFixed(2),
                };
            });

            setInvoicedeatils(updatedItemData);

            const Quantity = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const DiscountAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
            const TaxableAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
            const CGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);
            const gvAmount = parseFloat(formData.GVAmount) || 0;
            const UPIAmount = parseFloat(formData.UPIAmount) || 0;
            totalCalculation(Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvAmount, cardAmount, UPIAmount);

        }
        else if (name === 'AdditionalDiscountPercentage') {

            const AdditionalDiscountPercentage = parseFloat(value) || 0;
            setFormData((prevData) => ({
                ...prevData,
                AdditionalDiscountPercentage: AdditionalDiscountPercentage.toFixed(2),
                ModifiedBy: userId,
            }));
            const AdditionalDisc = parseFloat(AdditionalDiscountPercentage) || 0;
            const updatedItemData = invoicedeatils.map((item) => {

                let rate = parseFloat(item.Rate) || 0;
                let gstrate = parseFloat(item.GSTRate) || 0;
                let discountPercentage = parseFloat(item.DiscountPercentage) || 0;
                let quantity = parseFloat(item.Quantity) || 0;
                let amount = (quantity * rate).toFixed(2);
                let discamt = ((rate * discountPercentage) / 100).toFixed(2)
                let Addidiscamt = ((rate * AdditionalDisc) / 100).toFixed(2)
                let totdiscount = parseFloat(discamt) + parseFloat(Addidiscamt);
                let grate = (rate - totdiscount).toFixed(2);
                let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
                const taxableamount = (quantity * salerate).toFixed(2);
                const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

                let cgst = 0;
                let sgst = 0;
                let igst = 0;

                if (!formData.GSTNumber) {
                    cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                } else {
                    const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

                    if (gstNumberPrefix !== branchstate) {
                        igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
                    } else {
                        cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                        sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    }
                }

                const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

                return {
                    ...item,
                    Amount: amount,
                    AdditionalDiscountAmount: parseFloat(Addidiscamt * quantity).toFixed(2),
                    AdditionalDiscountPercentage: parseFloat(AdditionalDisc).toFixed(2),
                    DiscountAmount: parseFloat(discamt * quantity).toFixed(2),
                    TaxableAmount: parseFloat(taxableamount).toFixed(2),
                    CGSTAmount: parseFloat(cgst).toFixed(2),
                    SGSTAmount: parseFloat(sgst).toFixed(2),
                    IGSTAmount: parseFloat(igst).toFixed(2),
                    TotalAmount: parseFloat(totalAmount).toFixed(2),
                };
            });

            setInvoicedeatils(updatedItemData);

            const Quantity = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const DiscountAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
            const TaxableAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
            const CGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);
            const gvAmount = parseFloat(formData.GVAmount) || 0;
            const CardAmount = parseFloat(formData.CardAmount) || 0;
            const UPIAmount = parseFloat(formData.UPIAmount) || 0;
            totalCalculation(Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvAmount, CardAmount, UPIAmount);

        }
        else if (name === 'UPIAmount') {

            const upiAmount = parseFloat(value) || 0;
            setFormData((prevData) => ({
                ...prevData,
                UPIAmount: upiAmount.toFixed(2),
                ModifiedBy: userId,
            }));
            const AdditionalDisc = parseFloat(formData.AdditionalDiscountPercentage) || 0;
            const updatedItemData = invoicedeatils.map((item) => {

                let rate = parseFloat(item.Rate) || 0;
                let gstrate = parseFloat(item.GSTRate) || 0;
                let discountPercentage = parseFloat(item.DiscountPercentage) || 0;
                let quantity = parseFloat(item.Quantity) || 0;
                let amount = (quantity * rate).toFixed(2);
                let discamt = ((rate * discountPercentage) / 100).toFixed(2)
                let Addidiscamt = ((rate * AdditionalDisc) / 100).toFixed(2)
                let totdiscount = parseFloat(discamt) + parseFloat(Addidiscamt);
                let grate = (rate - totdiscount).toFixed(2);
                let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
                const taxableamount = (quantity * salerate).toFixed(2);
                const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

                let cgst = 0;
                let sgst = 0;
                let igst = 0;

                if (!formData.GSTNumber) {
                    cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                } else {
                    const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

                    if (gstNumberPrefix !== branchstate) {
                        igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
                    } else {
                        cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                        sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    }
                }

                const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

                return {
                    ...item,
                    Amount: amount,
                    AdditionalDiscountAmount: parseFloat(Addidiscamt * quantity).toFixed(2),
                    AdditionalDiscountPercentage: parseFloat(AdditionalDisc).toFixed(2),
                    DiscountAmount: parseFloat(discamt * quantity).toFixed(2),
                    TaxableAmount: parseFloat(taxableamount).toFixed(2),
                    CGSTAmount: parseFloat(cgst).toFixed(2),
                    SGSTAmount: parseFloat(sgst).toFixed(2),
                    IGSTAmount: parseFloat(igst).toFixed(2),
                    TotalAmount: parseFloat(totalAmount).toFixed(2),
                };
            });

            setInvoicedeatils(updatedItemData);

            const Quantity = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const DiscountAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
            const TaxableAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
            const CGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = updatedItemData.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);
            const gvAmount = parseFloat(formData.GVAmount) || 0;
            const CardAmount = parseFloat(formData.CardAmount) || 0;
            totalCalculation(Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvAmount, CardAmount, upiAmount);

        }
        else {

            setFormData((prevData) => ({
                ...prevData,
                [name]: type === 'checkbox' ? checked : value,
            }));

        }

    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);

        if (!formData.CustomerName) {
            setErrorMessage('Customer Name is required !');
            setIsLoading(false);
            return;
        }

        if (!formData.SaleBillNumber) {
            setErrorMessage('Sale Bill Number is required !');
            setIsLoading(false);
            return;
        }


        // Cash amount validation
        if (formData.CashAmount < 0) {
            setErrorMessage('Cash Amount less than 0 is not allowed!');
            setIsLoading(false);
            return;
        }

        // Card amount validation
        if (formData.CardAmount > 0) {
            if (!formData.CardNumber) {
                setErrorMessage('Card Number is required when Card Amount is greater than 0!');
                setIsLoading(false);
                return;
            }
            if (!selectedCardType) {
                setErrorMessage('Card Type is required when Card Amount is greater than 0!');
                setIsLoading(false);
                return;
            }
        }

        if (!selectedSalesMan) {
            setErrorMessage('Sales Man is required !');
            setIsLoading(false);
            return;
        }

        // Upi amount validation
        if (formData.UPIAmount > 0) {
            if (!formData.UPINumber) {
                setErrorMessage('UPI Number is required when UPI Amount is greater than 0!');
                setIsLoading(false);
                return;
            }
        }


        if (!invoicedeatils || invoicedeatils.length === 0) {
            setErrorMessage('Item Details are required!');
            setIsLoading(false);
            return;
        }

        setFormData(prevData => ({
            ...prevData,
            ModifiedBy: userId,
            BranchId: branchId,
            CompanyId: companyId,
            SalesManId: selectedSalesMan,
            CardType: selectedCardType
        }));

        const CreateData = {
            Sale: formData,
            SaleDetails: invoicedeatils
        };

        // Validate form data here if needed

        updateData('SaleReturnApi', `${id}`, CreateData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);


                if (response.response === 'Sale Return Updated Successfully') {
                    const SaleId = response.kotId;
                    handlePrint(SaleId);
                }
                history.push('/SaleReturnIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });
    };

    const handlePrint = async (SaleId) => {
        try {

            const response = await fetchData('SaleReturnApi', `/SalePrint/${SaleId}/${branchId}`, token);
            const labelData = response.response_data;
            const labelsToPrint = Array.isArray(labelData) ? labelData : [labelData];

            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
            iframeDocument.write('<html><head><style>@media print { header, footer { display: none !important; } }</style></head><body>');

            ReactDOM.render(
                <BillPrint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />,
                iframeDocument.body
            );

            iframeDocument.write('</body></html>');
            iframeDocument.close();
            // iframe.contentWindow.print();
            setTimeout(() => {
                iframe.contentWindow.print();
            }, 1000);

        } catch (error) {
            console.error('Error printing Invoice:', error);
        }
    };

    const removeRecord = (index) => {
        const isConfirmed = window.confirm("Are you sure you want to remove the record?");
        if (isConfirmed) {
            const updatedRecords = [...invoicedeatils];
            updatedRecords.splice(index, 1); // Remove the record at the specified index
            setInvoicedeatils(updatedRecords); // Update the state to reflect the removed record

            const Quantity = updatedRecords.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const DiscountAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
            const TaxableAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
            const CGSTAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);

            const gvAmount = parseFloat(formData.GVAmount) || 0;
            const CardAmount = parseFloat(formData.CardAmount) || 0;
            const UPIAmount = parseFloat(formData.UPIAmount) || 0;
            totalCalculation(Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvAmount, CardAmount, UPIAmount);

        }

    };

    //Items
    const [itemsOptions, setItemsrOptions] = useState([]);
    const [selectedItems, setSelectedItem] = useState("");

    useEffect(() => {
        fetchItems();
    }, []);

    const fetchItems = async () => {
        try {
            //const response = await fetchData('SaleReturnApi', `/Item/${companyId}/${branchId}`, token);
            const response = await fetchData('PurchaseApi', `/ItemSaleReturn/${companyId}/${id}/${inputValue}`, token);
            if (response.responseCode === '1111') {
                setItemDetails(response.response_data);
            }

            setFormData(prevData => ({
                ...prevData,
                BranchId: branchId,
                CompanyId: companyId,
                CreatedBy: userId,
            }));

        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    // FOR MODEL DATA (Invoice Details)
    const [modalData, setModalData] = useState({
        SlNo: '0',
        ItemName: '',
        ItemId: '',
        Quantity: '1',
        Rate: '',
        Amount: '',
        DiscountPercentage: '',
        DiscountAmount: '',
        HSNCode: '',
        GSTRate: '',
        TaxableAmount: '',
        CGSTAmount: '',
        SGSTAmount: '',
        IGSTAmount: '',
        TotalAmount: '',
        balanceStock: 0,
    });

    const closeModal = () => {
        setModalData({
            SlNo: '0',
            ItemName: '',
            ItemId: '',
            Quantity: '1',
            Rate: '',
            Amount: '',
            DiscountPercentage: '',
            DiscountAmount: '',
            HSNCode: '',
            GSTRate: '',
            TaxableAmount: '',
            CGSTAmount: '',
            SGSTAmount: '',
            IGSTAmount: '',
            TotalAmount: '',
            balanceStock: 0,
        });
        setSelectedItem();
        setIsModalOpen(false);
    };

    const saveModalData = () => {
        let isValid = true;
        let errors = "";
        setErrorMessageModel(errors);

        // Validation for ItemId
        if (!modalData.ItemId) {
            isValid = false;
            errors = "Item is required";
        }

        // Validation for Quantity
        if (!modalData.Quantity || isNaN(modalData.Quantity)) {
            isValid = false;
            errors = "Quantity must be a valid number";
        }

        if (isValid) {
            //setInvoicedeatils([...invoicedeatils, modalData]);
            const updatedInvoicedetails = [...invoicedeatils, modalData];
            const updatedInvoicedetailsSorted = updatedInvoicedetails.reverse();
            setInvoicedeatils(updatedInvoicedetailsSorted);

            setModalData({
                ...modalData,
                SlNo: '0',
                ItemName: '',
                ItemId: '',
                Quantity: '1',
                Rate: '',
                Amount: '',
                DiscountPercentage: '',
                DiscountAmount: '',
                HSNCode: '',
                GSTRate: '',
                TaxableAmount: '',
                CGSTAmount: '',
                SGSTAmount: '',
                IGSTAmount: '',
                TotalAmount: '',
                balanceStock: 0,
            });

            setSelectedItem(0);
            //closeModal();

            // Update the totals based on the updatedItemData
            const Quantity = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const DiscountAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.DiscountAmount), 0);
            const TaxableAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);
            const CGSTAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);

            const gvAmount = parseFloat(formData.GVAmount) || 0;
            const CardAmount = parseFloat(formData.CardAmount) || 0;
            const UPIAmount = parseFloat(formData.UPIAmount) || 0;
            totalCalculation(Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvAmount, CardAmount, UPIAmount);


        } else {

            console.log("Validation errors:", errors);
            setErrorMessageModel(errors);
        }

    };

    const totalCalculation = (Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, gvamt, CardAmount, UPIAmount) => {

        const gvAmount = parseFloat(gvamt) || 0;

        let netamount = parseFloat(TaxableAmount);
        let netAmt = netamount + parseFloat(CGSTAmount) + parseFloat(SGSTAmount) + parseFloat(IGSTAmount);
        let roundOffValue = Math.round(netAmt) - netAmt;
        let totalAmt = parseFloat((netAmt + roundOffValue)).toFixed(2);
        totalAmt = parseFloat(totalAmt - gvAmount).toFixed(2);
        let cashamt = parseFloat(totalAmt - CardAmount - UPIAmount).toFixed(2);

        setFormData((prevData) => ({
            ...prevData,
            TotalQuantity: Quantity,
            TotalAmount: Amount.toFixed(2),
            DiscountAmount: DiscountAmount.toFixed(2),
            TaxableAmount: TaxableAmount.toFixed(2),
            CGSTAmount: CGSTAmount.toFixed(2),
            SGSTAmount: SGSTAmount.toFixed(2),
            IGSTAmount: IGSTAmount.toFixed(2),
            RoundOff: roundOffValue.toFixed(2),
            GrandTotal: parseFloat(totalAmt).toFixed(2),
            CashAmount: parseFloat(cashamt).toFixed(2),
            GVAmount: gvAmount.toFixed(2),
            CardAmount: CardAmount.toFixed(2),
            UPIAmount: UPIAmount.toFixed(2),
            CashDiscount: 0,
            ModifiedBy: userId,
        }));
    };

    const [itemdetails, setItemDetails] = useState([]);
    const handleItemSelect = (selectedOption) => {
        setSelectedItem(selectedOption);
        setModalData({
            ...modalData,
            ItemName: selectedOption ? selectedOption.label : '',
            ItemId: selectedOption ? selectedOption.value : '',
        });

        // Use Array.prototype.find() to find the rate
        const selectedItemId = selectedOption ? selectedOption.value : '';
        const selectedItemDetail = itemdetails.find((itemDetail) => itemDetail.Id === selectedItemId);
        if (selectedItemDetail) {

            let quantity = parseFloat(modalData.Quantity) || 0;;
            let rate = parseFloat(selectedItemDetail.MRP.toFixed(2)) || 0;
            let gstrate = parseFloat(selectedItemDetail.GSTRate.toFixed(2)) || 0;
            let discountPercentage = parseFloat(selectedItemDetail.DiscountPercentage.toFixed(2)) || 0;

            let amount = (quantity * rate).toFixed(2);
            let discamt = ((rate * discountPercentage) / 100).toFixed(2)
            let grate = (rate - discamt).toFixed(2);
            let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
            const taxableamount = (quantity * salerate).toFixed(2);
            const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

            let cgst = 0;
            let sgst = 0;
            let igst = 0;

            if (!formData.GSTNumber) {
                cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
            } else {
                const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

                if (gstNumberPrefix !== branchstate) {
                    igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
                } else {
                    cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                }
            }

            const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

            setModalData({
                ...modalData,
                Rate: selectedItemDetail.MRP.toFixed(2), // Assuming Rate is a number
                GSTRate: selectedItemDetail.GSTRate.toFixed(2),
                HSNCode: selectedItemDetail.HSNCode,
                DiscountPercentage: selectedItemDetail.DiscountPercentage.toFixed(2),
                ItemName: selectedOption ? selectedOption.label : '',
                ItemId: selectedOption ? selectedOption.value : '',
                Amount: amount,
                DiscountAmount: parseFloat(discamt).toFixed(2),
                TaxableAmount: parseFloat(taxableamount).toFixed(2),
                CGSTAmount: parseFloat(cgst).toFixed(2),
                SGSTAmount: parseFloat(sgst).toFixed(2),
                IGSTAmount: parseFloat(igst).toFixed(2),
                TotalAmount: parseFloat(totalAmount).toFixed(2),
                balanceStock: selectedItemDetail.balanceStock,
            });

        } else {
            // Handle the case where the item detail is not found
            setModalData({
                ...modalData,
                Rate: '0.00',
                GSTRate: '0.00',
                ItemName: selectedOption ? selectedOption.label : '',
                ItemId: selectedOption ? selectedOption.value : '',
                GSTRate: '0',
                HSNCode: '',
                DiscountPercentage: '',
            });
        }
    };

    const [isValid, setIsValid] = useState(true);
    const handleModalInputChange = (e) => {
        const { name, value } = e.target;
        setModalData({
            ...modalData,
            [name]: value,
        });

        const intValue = parseInt(value, 10);

        if (intValue > modalData.balanceStock) {
            setIsValid(false);
        } else {
            setIsValid(true);
        }

        let quantity = parseFloat(value) || 0;
        let rate = parseFloat(modalData.Rate) || 0;
        let gstrate = parseFloat(modalData.GSTRate) || 0;
        let discountPercentage = parseFloat(modalData.DiscountPercentage) || 0;

        let amount = (quantity * rate).toFixed(2);
        let discamt = ((rate * discountPercentage) / 100).toFixed(2)
        let grate = (rate - discamt).toFixed(2);
        let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
        const taxableamount = (quantity * salerate).toFixed(2);
        const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

        let cgst = 0;
        let sgst = 0;
        let igst = 0;

        if (!formData.GSTNumber) {
            cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
            sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
        } else {
            const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

            if (gstNumberPrefix !== branchstate) {
                igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
            } else {
                cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
            }
        }

        const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

        setModalData({
            ...modalData,
            Quantity: quantity,
            Amount: amount,
            DiscountAmount: parseFloat(discamt).toFixed(2),
            TaxableAmount: parseFloat(taxableamount).toFixed(2),
            CGSTAmount: parseFloat(cgst).toFixed(2),
            SGSTAmount: parseFloat(sgst).toFixed(2),
            IGSTAmount: parseFloat(igst).toFixed(2),
            TotalAmount: parseFloat(totalAmount).toFixed(2),
        });
    };

    const [isModalOpen, setIsModalOpen] = useState(false);

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
        setSelectedOption(null); 
        fetchOptions('');
    };

    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    };

    const [selectedOption, setSelectedOption] = useState(null);
    const handleInputChange = (newValue) => newValue;

    const handleChangeDrop = (selectedOption) => {
        setSelectedOption(selectedOption);
        const selectedItemDetail = itemdetails.find((itemDetail) => itemDetail.Id === selectedOption.value);
        if (selectedItemDetail) {

            let quantity = parseFloat(modalData.Quantity) || 0;;
            let rate = parseFloat(selectedItemDetail.MRP.toFixed(2)) || 0;
            let gstrate = parseFloat(selectedItemDetail.GSTRate.toFixed(2)) || 0;
            let discountPercentage = parseFloat(selectedItemDetail.DiscountPercentage.toFixed(2)) || 0;

            let amount = (quantity * rate).toFixed(2);
            let discamt = ((rate * discountPercentage) / 100).toFixed(2)
            let grate = (rate - discamt).toFixed(2);
            let salerate = (grate / (1 + gstrate / 100)).toFixed(2);
            const taxableamount = (quantity * salerate).toFixed(2);
            const gstAmount = ((taxableamount * (gstrate)) / 100).toFixed(2);

            let cgst = 0;
            let sgst = 0;
            let igst = 0;

            if (!formData.GSTNumber) {
                cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
            } else {
                const gstNumberPrefix = formData.GSTNumber.toString().substring(0, 2);

                if (gstNumberPrefix !== branchstate) {
                    igst = ((taxableamount * (gstrate)) / 100).toFixed(2);
                } else {
                    cgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                    sgst = ((taxableamount * (gstrate / 2)) / 100).toFixed(2);
                }
            }

            const totalAmount = Math.round((parseFloat(taxableamount) + parseFloat(cgst) + parseFloat(sgst) + parseFloat(igst)).toFixed(2));

            setModalData({
                ...modalData,
                Rate: selectedItemDetail.MRP.toFixed(2),
                GSTRate: selectedItemDetail.GSTRate.toFixed(2),
                HSNCode: selectedItemDetail.HSNCode,
                DiscountPercentage: selectedItemDetail.DiscountPercentage.toFixed(2),
                ItemName: selectedOption ? selectedOption.label : '',
                ItemId: selectedOption ? selectedOption.value : '',
                Amount: amount,
                DiscountAmount: parseFloat(discamt).toFixed(2),
                TaxableAmount: parseFloat(taxableamount).toFixed(2),
                CGSTAmount: parseFloat(cgst).toFixed(2),
                SGSTAmount: parseFloat(sgst).toFixed(2),
                IGSTAmount: parseFloat(igst).toFixed(2),
                TotalAmount: parseFloat(totalAmount).toFixed(2),
                balanceStock: selectedItemDetail.balanceStock,
            });
        }
    };

    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-2 mx-auto" style={{ maxWidth: '100%' }}>

                <style>
                    {`
                        /* Hide scrollbar for Chrome, Safari, and Opera */
                        .container::-webkit-scrollbar {
                        width: 0.2em;
                        }

                        .container::-webkit-scrollbar-track {
                        background: rgba(255,255,255,0);
                        }

                        .container::-webkit-scrollbar-thumb {
                        background-color: rgba(255,255,255,0);
                        border-radius: 4px;
                        }
                    `}
                </style>

                <div className="w-full mb-2 flex">
                    <h6 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}> Sale Return - Edit</h6>
               
                    <Button
                        style={{ marginLeft: '8px', color: 'darkgreen' }}
                        onClick={handleSubmit}
                        disabled={isLoading}
                    >
                        <DoneAllIcon style={{ color: 'darkgreen', fontWeight: 'bolder' }} /> {isLoading ? <CircularProgress size={24} color="inherit" /> : <b>Update</b>}
                    </Button>

                    <Button
                        component={Link}
                        to="/SaleReturnIndex"
                        className="linkcolor"
                        style={{ marginLeft: '8px', color: 'darkred', fontWeight: 'bolder' }}
                    >
                        <ArrowCircleLeftIcon style={{ color: 'darkred', fontWeight: 'bolder' }} /> Back to List
                    </Button>

                </div>

                <div className="watermark">
                    <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                </div>
                {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                {successMessage && <p className="text-green-500">{successMessage}</p>}

                <div className="w-full mb-4 flex" style={{ marginTop: '-1%' }}>
                    <div className="container mx-auto mt-2 p-4 max-w-screen-md bg-tabcolor rounded-lg shadow-lg p-6" style={{ marginTop: '10px', backgroundColor: 'rgba(255, 255, 255, 0.5)', maxHeight: '500px', overflowY: 'auto', width: '100%', maxWidth: '100%' }}>

                        <div className="w-full mb-2 flex" style={{ marginTop: '-1.20%' }}>

                            <div className="w-3/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                    Customer Name
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.CustomerName}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="CUSTOMER NAME"
                                    name='CustomerName'
                                />
                            </div>

                            {roleName !== "SuperAdmin" ? (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                        Bill Date
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={formatDateForInput(formData.BillDate)}
                                        onChange={handleChange}
                                        type="date"
                                        name='BillDate'
                                        readOnly
                                    />
                                </div>

                            ) : (

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                        Bill Date
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={formatDateForInput(formData.BillDate)}
                                        onChange={handleChange}
                                        type="date"
                                        name='BillDate'
                                    />
                                </div>
                            )}

                            {roleName !== "SuperAdmin" ? (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                        Bill Number
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={formData.BillNumber}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="BILL NUMBER"
                                        name='BillNumber'
                                        readOnly
                                    />
                                </div>
                            ) : (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                        Bill Number
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={formData.BillNumber}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="BILL NUMBER"
                                        name='BillNumber'
                                    />
                                </div>
                            )}

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                    Total Quantity
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.TotalQuantity}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="TOTAL QUANTITY"
                                    name='TotalQuantity'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                    Addt'l. Disc %
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.AdditionalDiscountPercentage}
                                    onChange={handleChange}
                                    type="number"
                                    placeholder="Disc %"
                                    style={{ textAlign: 'right' }}
                                    name='AdditionalDiscountPercentage'
                                />
                            </div>

                        </div>

                        <div className="w-full mb-4 flex" style={{ marginTop: '-0.30%' }}>
                            <div className="w-3/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                    Address
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.CustomerAddress}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Address"
                                    name='CustomerAddress'
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                    GST Number
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.GSTNumber}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="GST Number"
                                    name='GSTNumber'
                                />
                            </div>

                            {roleName !== "SuperAdmin" ? (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                        Sale Bill No
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={formData.SaleBillNumber}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Sale Bill Number"
                                        name='SaleBillNumber'
                                        readOnly
                                    />
                                </div>
                            ) : (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                        Sale Bill No
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={formData.SaleBillNumber}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="Sale Bill Number"
                                        name='SaleBillNumber'
                                    />
                                </div>
                            )}

                            {roleName !== "SuperAdmin" ? (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                        Sale Bill Date
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={formatDateForInput(formData.SaleBillDate)}
                                        onChange={handleChange}
                                        type="date"
                                        name='SaleBillDate'
                                        readOnly
                                    />
                                </div>
                            ) : (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                        Sale Bill Date
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={formatDateForInput(formData.SaleBillDate)}
                                        onChange={handleChange}
                                        type="date"
                                        name='SaleBillDate'
                                    />
                                </div>
                            )}

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                    Sales Man
                                    <span className="text-red-500">*</span>
                                </label>
                                <select
                                    className={`custom-select ${selectedSalesMan ? 'fade-in' : 'fade-in'}`}
                                    style={{ height: '30px', fontSize: '12px' }} 
                                    value={selectedSalesMan}
                                    onChange={(e) => {
                                        const selectedValue = e.target.value;
                                        setSelectedSalesMan(selectedValue);
                                        setFormData((prevFormData) => ({
                                            ...prevFormData,
                                            SalesManId: selectedValue,
                                        }));
                                    }}
                                >
                                    <option value="">Select Sales Man</option>
                                    {dropdownSalesManOptions.map((category) => (
                                        <option key={category.Id} value={category.Id}>
                                            {category.Name}
                                        </option>
                                    ))}
                                </select>

                            </div>
                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                    Total
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"

                                    value={formData.GrandTotal}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Grand Total"
                                    name='GrandTotal'
                                    readOnly
                                    style={{ textAlign: 'right', fontWeight: 'bold' }}
                                />
                            </div>
                        </div>
                        <div className="w-full mb-2 flex" style={{ marginTop: '-1.50%' }}>
                            {/* Item Name */}
                            <div className="w-1/2 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="Weightage" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                    Item Name
                                </label>
                                <AsyncSelect
                                    cacheOptions
                                    loadOptions={fetchOptions}
                                    onInputChange={handleInputChange}
                                    onChange={handleChangeDrop}
                                    value={selectedOption}
                                    isSearchable
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            minHeight: '30px',
                                            height: '30px',
                                            marginTop: '5px',
                                        }),
                                        valueContainer: (provided) => ({
                                            ...provided,
                                            height: '30px',
                                            padding: '0 6px',
                                        }),
                                        input: (provided) => ({
                                            ...provided,
                                            margin: 0,
                                            padding: 0,
                                        }),
                                        indicatorsContainer: (provided) => ({
                                            ...provided,
                                            height: '30px',
                                        }),
                                        menuPortal: (provided) => ({
                                            ...provided,
                                            zIndex: 9999, 
                                        }),
                                    }}
                                    menuPortalTarget={document.body} 
                                />
                            </div>

                            {/* Quantity */}
                            <div className="w-1/7 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="MinimumStock" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                    Quantity
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right h-8"
                                    type="number"
                                    name="Quantity"
                                    placeholder="Quantity"
                                    value={modalData.Quantity}
                                    onChange={handleModalInputChange}
                                    max={modalData.balanceStock}
                                    min={1}
                                />
                                {!isValid && (
                                    <p className="text-red-500 text-xs italic">
                                        Quantity exceeds available stock.
                                    </p>
                                )}
                            </div>

                            <button
                                className="bg-green-500 hover:bg-green-600 text-white text-xs font-semibold px-3 py-1 rounded-full shadow-md transition duration-200"
                                onClick={saveModalData}
                                style={{ marginLeft: '10px', marginTop: '25px', width: '80px', height: '30px', cursor: 'pointer' }}
                            >
                                Add
                            </button>

                        </div>
                        <div className="w-full mb-2 flex" style={{ marginTop: '-0.20%' }}>
                            <div className="w-full mb-2 flex">
                                <TableContainer component={Paper}>
                                    <table className="table">
                                        <thead>
                                            <tr style={{ backgroundColor: '#A1D6B2' }}>
                                                <th style={{ padding: '2px', backgroundColor: '#27445D', textTransform: 'uppercase', fontSize: '13px', color: 'white', fontFamily: 'monospace' }}>Item Name</th>
                                                <th style={{ padding: '2px', backgroundColor: '#27445D', textTransform: 'uppercase', fontSize: '13px', textAlign: 'right', color: 'white', fontFamily: 'monospace' }}>Quantity</th>
                                                <th style={{ padding: '2px', backgroundColor: '#27445D', textTransform: 'uppercase', fontSize: '13px', textAlign: 'right', color: 'white', fontFamily: 'monospace' }}>MRP</th>
                                                <th style={{ padding: '2px', backgroundColor: '#27445D', textTransform: 'uppercase', fontSize: '13px', textAlign: 'right', color: 'white', fontFamily: 'monospace' }}>DISC %</th>
                                                <th style={{ padding: '2px', backgroundColor: '#27445D', textTransform: 'uppercase', fontSize: '13px', textAlign: 'right', color: 'white', fontFamily: 'monospace' }}>Amount</th>
                                                {roleName == "SuperAdmin" && (
                                                    <th style={{ padding: '2px', backgroundColor: '#27445D', textTransform: 'uppercase', fontSize: '13px', textAlign: 'right', color: 'white', fontFamily: 'monospace' }}>Action</th>
                                                )}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {invoicedeatils.map((invdetail, index) => (
                                                <tr key={index} className={invdetail.ColorCode === '#ffffff' ? 'white-row' : ''} style={{ width: '100%' }}>
                                                    <td style={{ padding: '2px', borderBottom: '1px solid black', borderRight: '1px solid grey', fontSize: '12px', fontWeight: 'bold', width: '45%' }}>{invdetail.ItemName}</td>
                                                    <td
                                                        style={{
                                                            padding: "2px",
                                                            borderBottom: "1px solid black",
                                                            borderRight: "1px solid grey",
                                                            fontSize: "12px",
                                                            fontWeight: "bold",
                                                            width: "10%",
                                                            textAlign: "right",
                                                        }}
                                                    >
                                                        <input
                                                            type="number"
                                                            value={invdetail.Quantity}
                                                            onChange={(e) => {
                                                                let value = Number(e.target.value);
                                                                // find max quantity allowed
                                                                const maxQty =
                                                                    //saleItemdeatils.find((item) => item.ItemId === invdetail.ItemId)?.Quantity ||
                                                                    0;

                                                                // if negative, force to 0
                                                                if (value < 0) value = 0;

                                                                // if exceeding, force to max
                                                                if (value > maxQty) value = maxQty;

                                                                // update state with corrected value
                                                                handleEdit(index, "Quantity", value);
                                                            }}
                                                            style={{
                                                                width: "100%",
                                                                fontSize: "13px",
                                                                fontWeight: "bold",
                                                                padding: "4px",
                                                                textAlign: "right",
                                                                backgroundColor: "#F7ECDE",
                                                            }}
                                                        />
                                                    </td>
                                                    <td style={{ padding: '2px', borderBottom: '1px solid black', borderRight: '1px solid grey', fontSize: '12px', fontWeight: 'bold', width: '10%', textAlign: 'right' }}>{invdetail.Rate}</td>
                                                    <td style={{ padding: '2px', borderBottom: '1px solid black', borderRight: '1px solid grey', fontSize: '12px', fontWeight: 'bold', width: '10%', textAlign: 'right' }}>{invdetail.DiscountPercentage}</td>
                                                    <td style={{ padding: '2px', borderBottom: '1px solid black', borderRight: '1px solid grey', fontSize: '12px', fontWeight: 'bold', width: '15%', textAlign: 'right' }}>{invdetail.TotalAmount}</td>

                                                    {roleName == "SuperAdmin" && (
                                                        <td style={{ padding: '2px', borderBottom: '1px solid black', borderRight: '1px solid grey', marginTop: '-15px', width: '10%', textAlign: 'right' }}>
                                                            <IconButton style={{ padding: '8px', marginTop: '-10px' }} onClick={() => removeRecord(index)}>
                                                                <DeleteIcon style={{ color: '#CD5656', fontSize: '19px' }} />
                                                            </IconButton>
                                                        </td>
                                                    )}
                                                </tr>
                                            ))}
                                        </tbody>
                                        
                                        {/* Footer Section */}
                                        <tfoot>
                                            <tr style={{
                                                backgroundColor: '#27445D',
                                                position: 'sticky',
                                                bottom: 0,
                                                boxShadow: '0px -2px 5px rgba(0, 0, 0, 0.1)',
                                                zIndex: 2
                                            }}>
                                                <td style={{ padding: '2px', fontWeight: 'bold', textAlign: 'right', fontSize: "13px", backgroundColor: '#D3DAD9' }} colSpan={1}></td>
                                                <td style={{ padding: '2px', fontWeight: 'bold', textAlign: 'right', fontSize: "13px", backgroundColor: '#D3DAD9', color: 'black' }}>
                                                    {invoicedeatils.reduce((sum, item) => sum + Number(item.Quantity || 0), 0)}
                                                </td>
                                                <td colSpan={2} style={{ padding: '2px', backgroundColor: '#D3DAD9' }}></td>
                                                <td style={{ padding: '2px', fontWeight: 'bold', textAlign: 'right', fontSize: "13px", backgroundColor: '#D3DAD9', color: 'black' }}>
                                                    {invoicedeatils.reduce((sum, item) => sum + Number(item.TotalAmount || 0), 0).toFixed(2)}
                                                </td>
                                                <td style={{ backgroundColor: '#D3DAD9' }}></td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </TableContainer>

                            </div>
                        </div>

                        <div className="w-full mb-2 flex" style={{ marginTop: '-0.80%' }}>
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ color: 'black', fontSize: '13px', fontFamily: 'monospace' }}>
                                Remarks
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                value={formData.Remarks}
                                onChange={handleChange}
                                type="text"
                                placeholder="Remarks"
                                name='Remarks'
                            />
                        </div>

                    </div>
                    {
                        isModalOpen && (
                            <div className="w-full mb-4 flex" style={{ marginLeft: '10px', width: '50%', marginTop: '10px' }}>
                                <div className="w-full pr-4">
                                    <div className="bg-teal-800 rounded-lg shadow-lg p-6">
                                        {errorMessageModel && <p className="text-red-500">{errorMessageModel}</p>}
                                        <p style={{ color: 'whitesmoke', fontWeight: 'bolder' }}>ADD ITEMS</p>
                                        <div className="w-full mb-4 flex">
                                            <div className="w-4/7 mr-3" style={{ marginLeft: '5px', width: '300px' }}>
                                                <label className="block uppercase tracking-wide text-white text-xs font-bold mb-2" htmlFor="Weightage">
                                                    Item Name
                                                </label>

                                                <AsyncSelect
                                                    cacheOptions
                                                    loadOptions={fetchOptions}
                                                    onInputChange={handleInputChange}
                                                    onChange={handleChangeDrop}
                                                    value={selectedOption}
                                                />

                                            </div>
                                            <div className="w-1/4 mr-3">
                                                <label className="block uppercase tracking-wide text-white text-xs font-bold mb-2" htmlFor="MinimumStock">
                                                    Quantity
                                                </label>
                                                <input
                                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                                    type="number"
                                                    name="Quantity"
                                                    placeholder="Quantity"
                                                    value={modalData.Quantity}
                                                    onChange={handleModalInputChange}
                                                    min={1}
                                                />
                                                {!isValid && (
                                                    <p className="text-red-500 text-xs italic">
                                                        Quantity exceeds available stock.
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                        <div className="w-1/2 mr-4" >
                                            <button className="bg-green-500 text-white px-4 py-2 rounded" onClick={saveModalData}>
                                                Add Record
                                            </button>
                                        </div>
                                        <div className="w-1/2 mr-4" style={{ marginLeft: '140px', marginTop: '-40px' }}>
                                            <button className="bg-blue-500 text-white px-4 py-2 rounded  ml-2" onClick={toggleModal} >
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    }


                </div>


            </div >
        </Fragment >

    );
};

export default SaleReturnEdit;